export const MOCK_TUTORIALS = [
  {
    "id": 9904,
    "title": "Kling AI: The Ultimate Video Generation Guide (2026)",
    "thumbnail": "https://img.youtube.com/vi/anACVZDNw6o/hqdefault.jpg",
    "duration": "18min",
    "level": "BEGINNER",
    "tags": [
      "#KlingAI",
      "#VideoGeneration"
    ],
    "views": "25012",
    "author": "AI Cinematic",
    "topic": "Kling AI",
    "url": "https://www.youtube.com/watch?v=anACVZDNw6o"
  },
  {
    "id": 9905,
    "title": "Sora vs Kling AI vs Luma - Full Comparison",
    "thumbnail": "https://img.youtube.com/vi/EWBsU0fSgPs/hqdefault.jpg",
    "duration": "25min",
    "level": "INTERMEDIATE",
    "tags": [
      "#KlingAI",
      "#Sora",
      "#Comparison"
    ],
    "views": "42199",
    "author": "Tech Comparer",
    "topic": "Kling AI",
    "url": "https://www.youtube.com/watch?v=EWBsU0fSgPs"
  },
  {
    "id": 9902,
    "title": "Nano Banana Advanced Workflows 2026",
    "thumbnail": "https://img.youtube.com/vi/JDErfeSMfcM/hqdefault.jpg",
    "duration": "45min",
    "level": "ADVANCED",
    "tags": [
      "#NanoBanana",
      "#workflow"
    ],
    "views": "8902",
    "author": "Tech Explainer",
    "topic": "Nano Banana",
    "url": "https://www.youtube.com/watch?v=JDErfeSMfcM"
  },
  {
    "id": 1,
    "title": "CLAUDE CODE FULL COURSE 4 HOURS: Build & Sell (2026)",
    "thumbnail": "https://img.youtube.com/vi/QoQBzR1NIqI/hqdefault.jpg",
    "duration": "4h10min",
    "level": "ADVANCED",
    "tags": [
      "#Claude",
      "#Anthropic"
    ],
    "views": "41805",
    "author": "AI Expert",
    "topic": "Claude",
    "url": "https://www.youtube.com/watch?v=QoQBzR1NIqI"
  },
  {
    "id": 2,
    "title": "ChatGPT Tutorial for Beginners: Build App with AI (2026)",
    "thumbnail": "https://img.youtube.com/vi/Hm3QR4dUQI4/hqdefault.jpg",
    "duration": "20min",
    "level": "BEGINNER",
    "tags": [
      "#chatgpt"
    ],
    "views": "49161",
    "author": "AI Expert",
    "topic": "chatgpt",
    "url": "https://www.youtube.com/watch?v=Hm3QR4dUQI4"
  },
  {
    "id": 3,
    "title": "Claude (Dispatch Setup) - How to Control Your Desktop from Your Phone",
    "thumbnail": "https://img.youtube.com/vi/0CO_JPE9AC0/hqdefault.jpg",
    "duration": "8min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Claude",
      "#Anthropic"
    ],
    "views": "49540",
    "author": "AI Expert",
    "topic": "Claude",
    "url": "https://www.youtube.com/watch?v=0CO_JPE9AC0"
  },
  {
    "id": 4,
    "title": "Master Gemini 3.1 for Work in 12 Minutes (2026)",
    "thumbnail": "https://img.youtube.com/vi/bTLmt9BKGVc/hqdefault.jpg",
    "duration": "12min",
    "level": "BEGINNER",
    "tags": [
      "#Gemini"
    ],
    "views": "38493",
    "author": "AI Expert",
    "topic": "Gemini",
    "url": "https://www.youtube.com/watch?v=bTLmt9BKGVc"
  },
  {
    "id": 5,
    "title": "The BEST AI Presentation Maker | Gamma App Tutorial 2026 (step by step)",
    "thumbnail": "https://img.youtube.com/vi/VgH5wWVy_64/hqdefault.jpg",
    "duration": "21min",
    "level": "BEGINNER",
    "tags": [
      "#Gamma"
    ],
    "views": "48902",
    "author": "AI Expert",
    "topic": "Gamma",
    "url": "https://www.youtube.com/watch?v=VgH5wWVy_64"
  },
  {
    "id": 6,
    "title": "Master Lovable In 24 Minutes",
    "thumbnail": "https://img.youtube.com/vi/rqvtLxwMklo/hqdefault.jpg",
    "duration": "24min",
    "level": "INTERMEDIATE",
    "tags": [
      "#lovable",
      "#nocode"
    ],
    "views": "39242",
    "author": "AI Expert",
    "topic": "lovable",
    "url": "https://www.youtube.com/watch?v=rqvtLxwMklo"
  },
  {
    "id": 7,
    "title": "I Tested Claude Cowork 2.0 for 48h (it's insane)",
    "thumbnail": "https://img.youtube.com/vi/aWAfpOi91vc/hqdefault.jpg",
    "duration": "13min",
    "level": "BEGINNER",
    "tags": [
      "#Claude",
      "#Anthropic"
    ],
    "views": "49204",
    "author": "AI Expert",
    "topic": "Claude",
    "url": "https://www.youtube.com/watch?v=aWAfpOi91vc"
  },
  {
    "id": 8,
    "title": "Nano Banana 2 Guide",
    "thumbnail": "https://img.youtube.com/vi/ZPAjfp_j4HM/hqdefault.jpg",
    "duration": "21min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Gemini"
    ],
    "views": "49597",
    "author": "AI Expert",
    "topic": "Gemini",
    "url": "https://www.youtube.com/watch?v=ZPAjfp_j4HM"
  },
  {
    "id": 9,
    "title": "Seedance 2.0 Advanced Techniques | Create Stunning 3D Worlds",
    "thumbnail": "https://img.youtube.com/vi/-txL10S0hPc/hqdefault.jpg",
    "duration": "17min",
    "level": "ADVANCED",
    "tags": [
      "#Seedance",
      "#video"
    ],
    "views": "36864",
    "author": "AI Expert",
    "topic": "Seedance",
    "url": "https://www.youtube.com/watch?v=-txL10S0hPc"
  },
  {
    "id": 10,
    "title": "Google AI Studio for Beginners (2026)",
    "thumbnail": "https://img.youtube.com/vi/UpYSNdA8a-M/hqdefault.jpg",
    "duration": "11min",
    "level": "BEGINNER",
    "tags": [
      "#Google",
      "#Studio"
    ],
    "views": "46417",
    "author": "AI Expert",
    "topic": "Google",
    "url": "https://www.youtube.com/watch?v=UpYSNdA8a-M"
  },
  {
    "id": 11,
    "title": "How to Use Higgsfield AI Better than 99% of People",
    "thumbnail": "https://img.youtube.com/vi/OxNlBqHex44/hqdefault.jpg",
    "duration": "11min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Higgsfield",
      "#video"
    ],
    "views": "38341",
    "author": "AI Expert",
    "topic": "Higgsfield",
    "url": "https://www.youtube.com/watch?v=OxNlBqHex44"
  },
  {
    "id": 12,
    "title": "Give Me 13 Minutes. I'll Teach You 80% of NotebookLM",
    "thumbnail": "https://img.youtube.com/vi/646GdYl2nKs/hqdefault.jpg",
    "duration": "13min",
    "level": "BEGINNER",
    "tags": [
      "#notebooklm"
    ],
    "views": "41768",
    "author": "AI Expert",
    "topic": "notebooklm",
    "url": "https://www.youtube.com/watch?v=646GdYl2nKs"
  },
  {
    "id": 13,
    "title": "How To Use Perplexity AI (Best AI Research Tool)",
    "thumbnail": "https://img.youtube.com/vi/nzgrB56LMbI/hqdefault.jpg",
    "duration": "14min",
    "level": "BEGINNER",
    "tags": [
      "#Perplexity"
    ],
    "views": "37354",
    "author": "AI Expert",
    "topic": "Perplexity",
    "url": "https://www.youtube.com/watch?v=nzgrB56LMbI"
  },
  {
    "id": 14,
    "title": "How To Master Google Gemini in 2026 (Free Course)",
    "thumbnail": "https://img.youtube.com/vi/-_FizlRlfYs/hqdefault.jpg",
    "duration": "34min",
    "level": "INTERMEDIATE",
    "tags": [
      "#google"
    ],
    "views": "50685",
    "author": "AI Expert",
    "topic": "google",
    "url": "https://www.youtube.com/watch?v=-_FizlRlfYs"
  },
  {
    "id": 15,
    "title": "100 hours of OpenClaw lessons in 35 minutes",
    "thumbnail": "https://img.youtube.com/vi/_kZCoW-Qxnc/hqdefault.jpg",
    "duration": "35min",
    "level": "ADVANCED",
    "tags": [
      "#OpenClaw"
    ],
    "views": "45997",
    "author": "AI Expert",
    "topic": "OpenClaw",
    "url": "https://www.youtube.com/watch?v=_kZCoW-Qxnc"
  },
  {
    "id": 16,
    "title": "FULL CANVA TUTORIAL 2026 [UPDATE!] | How To Use Canva For BEGINNERS!",
    "thumbnail": "https://img.youtube.com/vi/Ryv4Q1qmxHs/hqdefault.jpg",
    "duration": "2h01min",
    "level": "BEGINNER",
    "tags": [
      "#CANVA"
    ],
    "views": "41913",
    "author": "AI Expert",
    "topic": "CANVA",
    "url": "https://www.youtube.com/watch?v=Ryv4Q1qmxHs"
  },
  {
    "id": 17,
    "title": "The Only ElevenLabs Tutorial You'll Need (2026)",
    "thumbnail": "https://img.youtube.com/vi/Zozt9QfAwcg/hqdefault.jpg",
    "duration": "29min",
    "level": "INTERMEDIATE",
    "tags": [
      "#ElevenLabs"
    ],
    "views": "41820",
    "author": "AI Expert",
    "topic": "ElevenLabs",
    "url": "https://www.youtube.com/watch?v=Zozt9QfAwcg"
  },
  {
    "id": 18,
    "title": "Ultimate GROK 4 Guide 2025: How to Use GROK For Beginners",
    "thumbnail": "https://img.youtube.com/vi/V3YzhHlDt9c/hqdefault.jpg",
    "duration": "30min",
    "level": "BEGINNER",
    "tags": [
      "#grok"
    ],
    "views": "38598",
    "author": "AI Expert",
    "topic": "grok",
    "url": "https://www.youtube.com/watch?v=V3YzhHlDt9c"
  },
  {
    "id": 19,
    "title": "How to Use SUNO AI (Free Course)",
    "thumbnail": "https://img.youtube.com/vi/UCpqD0HgD9w/hqdefault.jpg",
    "duration": "1h30min",
    "level": "INTERMEDIATE",
    "tags": [
      "#SUNO"
    ],
    "views": "49454",
    "author": "AI Expert",
    "topic": "SUNO",
    "url": "https://www.youtube.com/watch?v=UCpqD0HgD9w"
  },
  {
    "id": 20,
    "title": "Complete Beginner's Guide to OpenAI\u2019s Codex App",
    "thumbnail": "https://img.youtube.com/vi/H9HoL70WdPQ/hqdefault.jpg",
    "duration": "43min",
    "level": "BEGINNER",
    "tags": [
      "#OpenAI"
    ],
    "views": "42091",
    "author": "AI Expert",
    "topic": "OpenAI",
    "url": "https://www.youtube.com/watch?v=H9HoL70WdPQ"
  },
  {
    "id": 21,
    "title": "Semrush One Tutorial for Beginners (2026)",
    "thumbnail": "https://img.youtube.com/vi/NWmR5GXTqWk/hqdefault.jpg",
    "duration": "1h01min",
    "level": "BEGINNER",
    "tags": [
      "#semrush"
    ],
    "views": "49589",
    "author": "AI Expert",
    "topic": "semrush",
    "url": "https://www.youtube.com/watch?v=NWmR5GXTqWk"
  },
  {
    "id": 22,
    "title": "30 ChatGPT 5.2 Hacks You Need to Know in 2026 (Become a PRO!)",
    "thumbnail": "https://img.youtube.com/vi/NJ8RmgY-jP0/hqdefault.jpg",
    "duration": "18min",
    "level": "INTERMEDIATE",
    "tags": [
      "#chatgpt"
    ],
    "views": "44724",
    "author": "AI Expert",
    "topic": "chatgpt",
    "url": "https://www.youtube.com/watch?v=NJ8RmgY-jP0"
  },
  {
    "id": 23,
    "title": "Invideo AI - Full Tutorial 2026: The AI Video Generator that does it All",
    "thumbnail": "https://img.youtube.com/vi/9rpOO0Bh7i0/hqdefault.jpg",
    "duration": "12min",
    "level": "BEGINNER",
    "tags": [
      "#Invideo"
    ],
    "views": "41901",
    "author": "AI Expert",
    "topic": "Invideo",
    "url": "https://www.youtube.com/watch?v=9rpOO0Bh7i0"
  },
  {
    "id": 24,
    "title": "The Complete TikTok for Business Tutorial 2026",
    "thumbnail": "https://img.youtube.com/vi/B8P9ErHGpxU/hqdefault.jpg",
    "duration": "18min",
    "level": "INTERMEDIATE",
    "tags": [
      "#tiktok"
    ],
    "views": "46589",
    "author": "AI Expert",
    "topic": "tiktok",
    "url": "https://www.youtube.com/watch?v=B8P9ErHGpxU"
  },
  {
    "id": 25,
    "title": "How To Create Your Own Music Using AI in Gemini (Lyria 3)",
    "thumbnail": "https://img.youtube.com/vi/CqzS3GyBSxk/hqdefault.jpg",
    "duration": "3min",
    "level": "BEGINNER",
    "tags": [
      "#lyria"
    ],
    "views": "49328",
    "author": "AI Expert",
    "topic": "lyria",
    "url": "https://www.youtube.com/watch?v=CqzS3GyBSxk"
  },
  {
    "id": 26,
    "title": "HubSpot CRM Tutorial for Beginners 2026 (Step-by-Step)",
    "thumbnail": "https://img.youtube.com/vi/t8QM5zunC44/hqdefault.jpg",
    "duration": "19min",
    "level": "BEGINNER",
    "tags": [
      "#HubSpot"
    ],
    "views": "35178",
    "author": "AI Expert",
    "topic": "HubSpot",
    "url": "https://www.youtube.com/watch?v=t8QM5zunC44"
  },
  {
    "id": 27,
    "title": "Google Antigravity - Full Tutorial 2026: How To Build an App",
    "thumbnail": "https://img.youtube.com/vi/_G00r4phw-Y/hqdefault.jpg",
    "duration": "18min",
    "level": "ADVANCED",
    "tags": [
      "#Google"
    ],
    "views": "48944",
    "author": "AI Expert",
    "topic": "Google",
    "url": "https://www.youtube.com/watch?v=_G00r4phw-Y"
  },
  {
    "id": 28,
    "title": "This Is How To Use Kling 3.0 Like A PRO (The Only Guide You Need)",
    "thumbnail": "https://img.youtube.com/vi/HTBfxEqDCdU/hqdefault.jpg",
    "duration": "19min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Kling",
      "#video"
    ],
    "views": "37525",
    "author": "AI Expert",
    "topic": "Kling",
    "url": "https://www.youtube.com/watch?v=HTBfxEqDCdU"
  },
  {
    "id": 29,
    "title": "Claude Code Tutorial for Beginners",
    "thumbnail": "https://img.youtube.com/vi/3HVH2Iuplqo/hqdefault.jpg",
    "duration": "35min",
    "level": "BEGINNER",
    "tags": [
      "#claude"
    ],
    "views": "49022",
    "author": "AI Expert",
    "topic": "claude",
    "url": "https://www.youtube.com/watch?v=3HVH2Iuplqo"
  },
  {
    "id": 30,
    "title": "Learn Adobe Photoshop in 43 Minutes (2026)",
    "thumbnail": "https://img.youtube.com/vi/Ppg7j0nai08/hqdefault.jpg",
    "duration": "43min",
    "level": "ADVANCED",
    "tags": [
      "#Adobe"
    ],
    "views": "33095",
    "author": "AI Expert",
    "topic": "Adobe",
    "url": "https://www.youtube.com/watch?v=Ppg7j0nai08"
  },
  {
    "id": 31,
    "title": "Windsurf Tutorial for Beginners (AI Code Editor)",
    "thumbnail": "https://img.youtube.com/vi/8TcWGk1DJVs/hqdefault.jpg",
    "duration": "19min",
    "level": "INTERMEDIATE",
    "tags": [
      "#codeium"
    ],
    "views": "48054",
    "author": "AI Expert",
    "topic": "codeium",
    "url": "https://www.youtube.com/watch?v=8TcWGk1DJVs"
  },
  {
    "id": 32,
    "title": "9 INSANE Perplexity Computer Use Cases (do anything)",
    "thumbnail": "https://img.youtube.com/vi/JTRCptpReaE/hqdefault.jpg",
    "duration": "19min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Perplexity"
    ],
    "views": "40462",
    "author": "AI Expert",
    "topic": "Perplexity",
    "url": "https://www.youtube.com/watch?v=JTRCptpReaE"
  },
  {
    "id": 33,
    "title": "Getting started with Codex",
    "thumbnail": "https://img.youtube.com/vi/px7XlbYgk7I/hqdefault.jpg",
    "duration": "53min",
    "level": "ADVANCED",
    "tags": [
      "#Codex"
    ],
    "views": "40182",
    "author": "AI Expert",
    "topic": "Codex",
    "url": "https://www.youtube.com/watch?v=px7XlbYgk7I"
  },
  {
    "id": 34,
    "title": "Midjourney - Tutorial for Beginners in 12 MINS! [ FULL GUIDE 2026 ]",
    "thumbnail": "https://img.youtube.com/vi/7z7OxhNP6Qs/hqdefault.jpg",
    "duration": "11min",
    "level": "BEGINNER",
    "tags": [
      "#Midjourney"
    ],
    "views": "32850",
    "author": "AI Expert",
    "topic": "Midjourney",
    "url": "https://www.youtube.com/watch?v=7z7OxhNP6Qs"
  },
  {
    "id": 35,
    "title": "How to Use HeyGen in 2026 (Step-by-Step Beginner Tutorial)",
    "thumbnail": "https://img.youtube.com/vi/RTmlxuroR50/hqdefault.jpg",
    "duration": "18min",
    "level": "BEGINNER",
    "tags": [
      "#Heygen",
      "#video"
    ],
    "views": "38095",
    "author": "AI Expert",
    "topic": "Heygen",
    "url": "https://www.youtube.com/watch?v=RTmlxuroR50"
  },
  {
    "id": 36,
    "title": "VEED.IO Complete Tutorial for Beginners 2026 (Step By Step)",
    "thumbnail": "https://img.youtube.com/vi/ppZdHFKpii0/hqdefault.jpg",
    "duration": "20min",
    "level": "BEGINNER",
    "tags": [
      "#VEED",
      "#Video"
    ],
    "views": "38614",
    "author": "AI Expert",
    "topic": "VEED",
    "url": "https://www.youtube.com/watch?v=ppZdHFKpii0"
  },
  {
    "id": 37,
    "title": "Base44 Tutorial for Beginners",
    "thumbnail": "https://img.youtube.com/vi/WF_sgw1u1NQ/hqdefault.jpg",
    "duration": "10min",
    "level": "BEGINNER",
    "tags": [
      "#"
    ],
    "views": "45812",
    "author": "AI Expert",
    "topic": "Other",
    "url": "https://www.youtube.com/watch?v=WF_sgw1u1NQ"
  },
  {
    "id": 38,
    "title": "Higgsfield AI Ultimate Tutorial (2026)",
    "thumbnail": "https://img.youtube.com/vi/cksEVv1tArI/hqdefault.jpg",
    "duration": "49min",
    "level": "BEGINNER",
    "tags": [
      "#Higgsfield"
    ],
    "views": "39242",
    "author": "AI Expert",
    "topic": "Higgsfield",
    "url": "https://www.youtube.com/watch?v=cksEVv1tArI"
  },
  {
    "id": 39,
    "title": "Notion AI Tutorial: Is It Really Worth It? (2025)",
    "thumbnail": "https://img.youtube.com/vi/SnbMRRZ2_Ag/hqdefault.jpg",
    "duration": "16min",
    "level": "BEGINNER",
    "tags": [
      "#Notion",
      "#ai"
    ],
    "views": "37382",
    "author": "AI Expert",
    "topic": "Notion",
    "url": "https://www.youtube.com/watch?v=SnbMRRZ2_Ag"
  },
  {
    "id": 40,
    "title": "Full Notion Tutorial 2026 - Beginner To Master",
    "thumbnail": "https://img.youtube.com/vi/FI1ABCgKxeY/hqdefault.jpg",
    "duration": "11h36min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Notion"
    ],
    "views": "38090",
    "author": "AI Expert",
    "topic": "Notion",
    "url": "https://www.youtube.com/watch?v=FI1ABCgKxeY"
  },
  {
    "id": 41,
    "title": "Ultimate OpenClaw Tutorial: How to Set up & Use for Beginners (Clawdbot)\u200b",
    "thumbnail": "https://img.youtube.com/vi/NA8C8jIQNeM/hqdefault.jpg",
    "duration": "19min",
    "level": "BEGINNER",
    "tags": [
      "#clawdbot",
      "#ai"
    ],
    "views": "32138",
    "author": "AI Expert",
    "topic": "clawdbot",
    "url": "https://www.youtube.com/watch?v=NA8C8jIQNeM"
  },
  {
    "id": 42,
    "title": "How To Use Google VEO 3.1 NEW INSANE FEATURES To Create Realistic Videos",
    "thumbnail": "https://img.youtube.com/vi/-E3oZ21BB2k/hqdefault.jpg",
    "duration": "18min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Veo"
    ],
    "views": "39549",
    "author": "AI Expert",
    "topic": "Veo",
    "url": "https://www.youtube.com/watch?v=-E3oZ21BB2k"
  },
  {
    "id": 43,
    "title": "Cursor AI Tutorial for Beginners: Build App with AI (2026)",
    "thumbnail": "https://img.youtube.com/vi/oQDCAJnr1aU/hqdefault.jpg",
    "duration": "23min",
    "level": "BEGINNER",
    "tags": [
      "#cursor",
      "#ai"
    ],
    "views": "45720",
    "author": "AI Expert",
    "topic": "cursor",
    "url": "https://www.youtube.com/watch?v=oQDCAJnr1aU"
  },
  {
    "id": 44,
    "title": "Master n8n in 2 Hours: Complete Beginner\u2019s Guide for 2025",
    "thumbnail": "https://img.youtube.com/vi/AURnISajubk/hqdefault.jpg",
    "duration": "2h10min",
    "level": "INTERMEDIATE",
    "tags": [
      "#n8n"
    ],
    "views": "32005",
    "author": "AI Expert",
    "topic": "n8n",
    "url": "https://www.youtube.com/watch?v=AURnISajubk"
  },
  {
    "id": 45,
    "title": "15 Ways to Use Nano Banana Pro: How to Use Google's Best AI Image Model",
    "thumbnail": "https://img.youtube.com/vi/JDErfeSMfcM/hqdefault.jpg",
    "duration": "17min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Gemini"
    ],
    "views": "36518",
    "author": "AI Expert",
    "topic": "Gemini",
    "url": "https://www.youtube.com/watch?v=JDErfeSMfcM"
  },
  {
    "id": 46,
    "title": "Framer - Full Tutorial for Beginners 2026: How to Use Framer AI",
    "thumbnail": "https://img.youtube.com/vi/izpblc6ppwk/hqdefault.jpg",
    "duration": "25min",
    "level": "BEGINNER",
    "tags": [
      "#framer",
      "#nocode"
    ],
    "views": "46799",
    "author": "AI Expert",
    "topic": "framer",
    "url": "https://www.youtube.com/watch?v=izpblc6ppwk"
  },
  {
    "id": 47,
    "title": "How to Create Long-Form Videos with Free Grok AI (2026 Tutorial)",
    "thumbnail": "https://img.youtube.com/vi/yTp0tkc2EVg/hqdefault.jpg",
    "duration": "17min",
    "level": "BEGINNER",
    "tags": [
      "#Grok"
    ],
    "views": "40601",
    "author": "AI Expert",
    "topic": "Grok",
    "url": "https://www.youtube.com/watch?v=yTp0tkc2EVg"
  },
  {
    "id": 48,
    "title": "Udio AI Tutorial: Make AI Music for Free",
    "thumbnail": "https://img.youtube.com/vi/XXyq_x-7Mfg/hqdefault.jpg",
    "duration": "12min",
    "level": "BEGINNER",
    "tags": [
      "#Udio"
    ],
    "views": "39086",
    "author": "AI Expert",
    "topic": "Udio",
    "url": "https://www.youtube.com/watch?v=XXyq_x-7Mfg"
  },
  {
    "id": 49,
    "title": "How To Use Replit Agent For Beginners",
    "thumbnail": "https://img.youtube.com/vi/VXrVVUPst0w/hqdefault.jpg",
    "duration": "7min",
    "level": "BEGINNER",
    "tags": [
      "#Replit"
    ],
    "views": "43327",
    "author": "AI Expert",
    "topic": "Replit",
    "url": "https://www.youtube.com/watch?v=VXrVVUPst0w"
  },
  {
    "id": 50,
    "title": "Leonardo AI - Tutorial for Beginners - How to Use [ FULL GUIDE 2026 ]",
    "thumbnail": "https://img.youtube.com/vi/oitdcBS2yOk/hqdefault.jpg",
    "duration": "18min",
    "level": "BEGINNER",
    "tags": [
      "#Leonardo",
      "#Tutorial"
    ],
    "views": "33334",
    "author": "AI Expert",
    "topic": "Leonardo",
    "url": "https://www.youtube.com/watch?v=oitdcBS2yOk"
  },
  {
    "id": 51,
    "title": "Google AI Studio - Full Tutorial 2026: How To Build an App",
    "thumbnail": "https://img.youtube.com/vi/Dem3ZSQ6RVM/hqdefault.jpg",
    "duration": "16min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Google",
      "#Studio"
    ],
    "views": "29415",
    "author": "AI Expert",
    "topic": "Google",
    "url": "https://www.youtube.com/watch?v=Dem3ZSQ6RVM"
  },
  {
    "id": 52,
    "title": "The Ultimate MiniMax Hailuo Guide (2026 Full Tutorial)",
    "thumbnail": "https://img.youtube.com/vi/aI82rYGiRk0/hqdefault.jpg",
    "duration": "1h01min",
    "level": "INTERMEDIATE",
    "tags": [
      "#MiniMax",
      "#Video"
    ],
    "views": "39094",
    "author": "AI Expert",
    "topic": "MiniMax",
    "url": "https://www.youtube.com/watch?v=aI82rYGiRk0"
  },
  {
    "id": 53,
    "title": "Emergent AI Tutorial - 2026 | How to Create a Production-Ready App Using Emergent AI",
    "thumbnail": "https://img.youtube.com/vi/Mm6f7JgJwRs/hqdefault.jpg",
    "duration": "9min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Emergent",
      "#nocode"
    ],
    "views": "41675",
    "author": "AI Expert",
    "topic": "Emergent",
    "url": "https://www.youtube.com/watch?v=Mm6f7JgJwRs"
  },
  {
    "id": 54,
    "title": "ClickUp Tutorial for Beginners (Step by Step)",
    "thumbnail": "https://img.youtube.com/vi/eFe64U1WVs8/hqdefault.jpg",
    "duration": "1h06min",
    "level": "BEGINNER",
    "tags": [
      "#clickup"
    ],
    "views": "41735",
    "author": "AI Expert",
    "topic": "clickup",
    "url": "https://www.youtube.com/watch?v=eFe64U1WVs8"
  },
  {
    "id": 55,
    "title": "CapCut Beginner Tutorial (2026) - Beginner to Pro",
    "thumbnail": "https://img.youtube.com/vi/Zv9u0aLkfK0/hqdefault.jpg",
    "duration": "17min",
    "level": "INTERMEDIATE",
    "tags": [
      "#CapCut",
      "#Video"
    ],
    "views": "32285",
    "author": "AI Expert",
    "topic": "CapCut",
    "url": "https://www.youtube.com/watch?v=Zv9u0aLkfK0"
  },
  {
    "id": 56,
    "title": "Google Gemini FULL COURSE 3 HOURS (Build & Automate Anything)",
    "thumbnail": "https://img.youtube.com/vi/FiVR9FBdpZA/hqdefault.jpg",
    "duration": "3h17min",
    "level": "ADVANCED",
    "tags": [
      "#Gemini"
    ],
    "views": "33514",
    "author": "AI Expert",
    "topic": "Gemini",
    "url": "https://www.youtube.com/watch?v=FiVR9FBdpZA"
  },
  {
    "id": 57,
    "title": "Hostinger AI Website Builder Tutorial 2026 - Step by Step",
    "thumbnail": "https://img.youtube.com/vi/2thLAVH8gb4/hqdefault.jpg",
    "duration": "35min",
    "level": "BEGINNER",
    "tags": [
      "#Hostinger"
    ],
    "views": "44035",
    "author": "AI Expert",
    "topic": "Hostinger",
    "url": "https://www.youtube.com/watch?v=2thLAVH8gb4"
  },
  {
    "id": 58,
    "title": "How to Use AI in Illustrator | Latest 2025 Update",
    "thumbnail": "https://img.youtube.com/vi/EGZ6biu5_4g/hqdefault.jpg",
    "duration": "8min",
    "level": "BEGINNER",
    "tags": [
      "#adobe",
      "#ai"
    ],
    "views": "41793",
    "author": "AI Expert",
    "topic": "adobe",
    "url": "https://www.youtube.com/watch?v=EGZ6biu5_4g"
  },
  {
    "id": 59,
    "title": "you need to learn MCP RIGHT NOW!! (Model Context Protocol)",
    "thumbnail": "https://img.youtube.com/vi/GuTcle5edjk/hqdefault.jpg",
    "duration": "38min",
    "level": "ADVANCED",
    "tags": [
      "#MCP"
    ],
    "views": "31931",
    "author": "AI Expert",
    "topic": "MCP",
    "url": "https://www.youtube.com/watch?v=GuTcle5edjk"
  },
  {
    "id": 60,
    "title": "ULTIMATE GPT IMAGE 1.5 TUTORIAL: 15 PROMPT TECHNIQUES",
    "thumbnail": "https://img.youtube.com/vi/QT1nMo-QMDQ/hqdefault.jpg",
    "duration": "26min",
    "level": "INTERMEDIATE",
    "tags": [
      "#GPT"
    ],
    "views": "30888",
    "author": "AI Expert",
    "topic": "GPT",
    "url": "https://www.youtube.com/watch?v=QT1nMo-QMDQ"
  },
  {
    "id": 61,
    "title": "How to Use Seedance 2.0 (Full Tutorial) | ByteDance AI Video",
    "thumbnail": "https://img.youtube.com/vi/cGENab64va8/hqdefault.jpg",
    "duration": "2min",
    "level": "BEGINNER",
    "tags": [
      "#Seedance",
      "#Video"
    ],
    "views": "37201",
    "author": "AI Expert",
    "topic": "Seedance",
    "url": "https://www.youtube.com/watch?v=cGENab64va8"
  },
  {
    "id": 62,
    "title": "New to MindStudio? Here's How to Get Started",
    "thumbnail": "https://img.youtube.com/vi/-KQ6rP-f8xc/hqdefault.jpg",
    "duration": "3min",
    "level": "BEGINNER",
    "tags": [
      "#MindStudio"
    ],
    "views": "29736",
    "author": "AI Expert",
    "topic": "MindStudio",
    "url": "https://www.youtube.com/watch?v=-KQ6rP-f8xc"
  },
  {
    "id": 63,
    "title": "How to Create AI Voiceovers using Murf AI - Tutorial",
    "thumbnail": "https://img.youtube.com/vi/TDKnB0CAKzA/hqdefault.jpg",
    "duration": "9min",
    "level": "BEGINNER",
    "tags": [
      "#AI"
    ],
    "views": "40449",
    "author": "AI Expert",
    "topic": "Other",
    "url": "https://www.youtube.com/watch?v=TDKnB0CAKzA"
  },
  {
    "id": 64,
    "title": "Generate Commercially Safe Stock Images and Turn Them into Ads Using AI",
    "thumbnail": "https://img.youtube.com/vi/aaiJcLTW4vo/hqdefault.jpg",
    "duration": "5min",
    "level": "BEGINNER",
    "tags": [
      "#adcreative"
    ],
    "views": "28163",
    "author": "AI Expert",
    "topic": "adcreative",
    "url": "https://www.youtube.com/watch?v=aaiJcLTW4vo"
  },
  {
    "id": 65,
    "title": "Transform Product Photos into Powerful Photoshoot Ads: Master AI Photoshoots for Unbeatable Ads",
    "thumbnail": "https://img.youtube.com/vi/qofnDE5oZhs/hqdefault.jpg",
    "duration": "8min",
    "level": "BEGINNER",
    "tags": [
      "#adcreative"
    ],
    "views": "42259",
    "author": "AI Expert",
    "topic": "adcreative",
    "url": "https://www.youtube.com/watch?v=qofnDE5oZhs"
  },
  {
    "id": 66,
    "title": "Take Your ADS To the NEXT Level with AI: Strategies, Creatives, Texts, & Audiences",
    "thumbnail": "https://img.youtube.com/vi/6G4maeeb-Dc/hqdefault.jpg",
    "duration": "6min",
    "level": "BEGINNER",
    "tags": [
      "#adcreative",
      "#ai"
    ],
    "views": "38134",
    "author": "AI Expert",
    "topic": "adcreative",
    "url": "https://www.youtube.com/watch?v=6G4maeeb-Dc"
  },
  {
    "id": 67,
    "title": "AI Agents 101 - MindStudio AI Agent Build Workshop (02/27/2026)",
    "thumbnail": "https://img.youtube.com/vi/CU8j1gjF1Ag/hqdefault.jpg",
    "duration": "1h28min",
    "level": "ADVANCED",
    "tags": [
      "#MindStudio"
    ],
    "views": "27893",
    "author": "AI Expert",
    "topic": "MindStudio",
    "url": "https://www.youtube.com/watch?v=CU8j1gjF1Ag"
  },
  {
    "id": 68,
    "title": "Complete Guide: How to Remove Objects from Video Online | Vidnoz AI",
    "thumbnail": "https://img.youtube.com/vi/bojH67GhcF8/hqdefault.jpg",
    "duration": "2min",
    "level": "BEGINNER",
    "tags": [
      "#Vidnoz"
    ],
    "views": "37345",
    "author": "AI Expert",
    "topic": "Vidnoz",
    "url": "https://www.youtube.com/watch?v=bojH67GhcF8"
  },
  {
    "id": 69,
    "title": "Sprout Social Tutorial 2026 (Full In-Depth Tutorial)",
    "thumbnail": "https://img.youtube.com/vi/xx6x1NYOiYY/hqdefault.jpg",
    "duration": "29min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Sprout"
    ],
    "views": "34874",
    "author": "AI Expert",
    "topic": "Sprout",
    "url": "https://www.youtube.com/watch?v=xx6x1NYOiYY"
  },
  {
    "id": 70,
    "title": "Suno Studio Tutorial: A Complete Beginner's Guide (2026)",
    "thumbnail": "https://img.youtube.com/vi/qR4BefPvSiI/hqdefault.jpg",
    "duration": "13min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Suno",
      "#Studio",
      "#Tutorial"
    ],
    "views": "28659",
    "author": "AI Expert",
    "topic": "Suno",
    "url": "https://www.youtube.com/watch?v=qR4BefPvSiI"
  },
  {
    "id": 71,
    "title": "Runway Gen 4.5 Motion Sketch \u2013 Image to Video: Beginners Guide",
    "thumbnail": "https://img.youtube.com/vi/hZHy0f7Uy-s/hqdefault.jpg",
    "duration": "13min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Runway"
    ],
    "views": "40048",
    "author": "AI Expert",
    "topic": "Runway",
    "url": "https://www.youtube.com/watch?v=hZHy0f7Uy-s"
  },
  {
    "id": 72,
    "title": "ULTIMATE Descript Tutorial for Beginners in 2026 | How to Edit Fast Using AI",
    "thumbnail": "https://img.youtube.com/vi/L4lUwaI7NSI/hqdefault.jpg",
    "duration": "25min",
    "level": "BEGINNER",
    "tags": [
      "#Descript",
      "#Tutorial"
    ],
    "views": "31972",
    "author": "AI Expert",
    "topic": "Descript",
    "url": "https://www.youtube.com/watch?v=L4lUwaI7NSI"
  },
  {
    "id": 73,
    "title": "How to Extend AI Video Clips in Grok Imagine",
    "thumbnail": "https://img.youtube.com/vi/DMXA0qGf-1s/hqdefault.jpg",
    "duration": "3min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Extend",
      "#Video"
    ],
    "views": "33094",
    "author": "AI Expert",
    "topic": "Extend",
    "url": "https://www.youtube.com/watch?v=DMXA0qGf-1s"
  },
  {
    "id": 74,
    "title": "Make Epic AI Videos in 10 Minutes | Luma Ray3 Tutorial",
    "thumbnail": "https://img.youtube.com/vi/9km2LTSZeqE/hqdefault.jpg",
    "duration": "9min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Luma"
    ],
    "views": "37127",
    "author": "AI Expert",
    "topic": "Luma",
    "url": "https://www.youtube.com/watch?v=9km2LTSZeqE"
  },
  {
    "id": 75,
    "title": "Master NEW NotebookLM in 23 Minutes",
    "thumbnail": "https://img.youtube.com/vi/vo6RrBsR-A0/hqdefault.jpg",
    "duration": "22min",
    "level": "INTERMEDIATE",
    "tags": [
      "#NotebookLM"
    ],
    "views": "38492",
    "author": "AI Expert",
    "topic": "NotebookLM",
    "url": "https://www.youtube.com/watch?v=vo6RrBsR-A0"
  },
  {
    "id": 76,
    "title": "Grok Imagine - Insightful TUTORIAL 2026 [+Extend From Frame]",
    "thumbnail": "https://img.youtube.com/vi/OuPoJC38Dmo/hqdefault.jpg",
    "duration": "17min",
    "level": "BEGINNER",
    "tags": [
      "#Grok",
      "#video"
    ],
    "views": "29065",
    "author": "AI Expert",
    "topic": "Grok",
    "url": "https://www.youtube.com/watch?v=OuPoJC38Dmo"
  },
  {
    "id": 77,
    "title": "How to Use Zapier in 2026: Complete Setup & Strategy",
    "thumbnail": "https://img.youtube.com/vi/AqVB9ZU9cGg/hqdefault.jpg",
    "duration": "1h38min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Zapier"
    ],
    "views": "36810",
    "author": "AI Expert",
    "topic": "Zapier",
    "url": "https://www.youtube.com/watch?v=AqVB9ZU9cGg"
  },
  {
    "id": 78,
    "title": "Qwen-Image-2512 ComfyUI Tutorial: Photorealism Boost - Easy Setup + Lightning 2026",
    "thumbnail": "https://img.youtube.com/vi/jc1SDyY59h4/hqdefault.jpg",
    "duration": "8min",
    "level": "ADVANCED",
    "tags": [
      "#Qwen"
    ],
    "views": "32720",
    "author": "AI Expert",
    "topic": "Qwen",
    "url": "https://www.youtube.com/watch?v=jc1SDyY59h4"
  },
  {
    "id": 79,
    "title": "TOP 20 Midjourney Prompts That Will BLOW YOUR MIND",
    "thumbnail": "https://img.youtube.com/vi/44-68lRT0mo/hqdefault.jpg",
    "duration": "10min",
    "level": "BEGINNER",
    "tags": [
      "#AI"
    ],
    "views": "29218",
    "author": "AI Expert",
    "topic": "Other",
    "url": "https://www.youtube.com/watch?v=44-68lRT0mo"
  },
  {
    "id": 80,
    "title": "How to Create Your Own Personal GPT with Microsoft Copilot",
    "thumbnail": "https://img.youtube.com/vi/MwEF8dTToBs/hqdefault.jpg",
    "duration": "8min",
    "level": "BEGINNER",
    "tags": [
      "#gpt",
      "#ai"
    ],
    "views": "28976",
    "author": "AI Expert",
    "topic": "gpt",
    "url": "https://www.youtube.com/watch?v=MwEF8dTToBs"
  },
  {
    "id": 81,
    "title": "FULL AI OFM COURSE 2026 (PART 1)",
    "thumbnail": "https://img.youtube.com/vi/X2IOKt_pwgI/hqdefault.jpg",
    "duration": "29min",
    "level": "ADVANCED",
    "tags": [
      "#AI"
    ],
    "views": "37790",
    "author": "AI Expert",
    "topic": "Other",
    "url": "https://www.youtube.com/watch?v=X2IOKt_pwgI"
  },
  {
    "id": 82,
    "title": "How to use QuillBot AI in 2026 | Everything you need to know!",
    "thumbnail": "https://img.youtube.com/vi/pEDy9-FqsaA/hqdefault.jpg",
    "duration": "5min",
    "level": "BEGINNER",
    "tags": [
      "#QuillBot"
    ],
    "views": "30015",
    "author": "AI Expert",
    "topic": "QuillBot",
    "url": "https://www.youtube.com/watch?v=pEDy9-FqsaA"
  },
  {
    "id": 83,
    "title": "FULL Claude Tutorial for Beginners in 2026! (Become a PRO!)",
    "thumbnail": "https://img.youtube.com/vi/rRrBbyv3ChM/hqdefault.jpg",
    "duration": "49min",
    "level": "BEGINNER",
    "tags": [
      "#Claude",
      "#Tutorial"
    ],
    "views": "33360",
    "author": "AI Expert",
    "topic": "Claude",
    "url": "https://www.youtube.com/watch?v=rRrBbyv3ChM"
  },
  {
    "id": 84,
    "title": "The Best Microsoft Copilot Tips For Prompts",
    "thumbnail": "https://img.youtube.com/vi/mgFgNC3PNZc/hqdefault.jpg",
    "duration": "4min",
    "level": "BEGINNER",
    "tags": [
      "#Microsoft"
    ],
    "views": "33698",
    "author": "AI Expert",
    "topic": "Microsoft",
    "url": "https://www.youtube.com/watch?v=mgFgNC3PNZc"
  },
  {
    "id": 85,
    "title": "Create Cinematic Ai Videos for FREE with Minimax! - Prompts & Tutorial",
    "thumbnail": "https://img.youtube.com/vi/dwpEP4TY1ME/hqdefault.jpg",
    "duration": "7min",
    "level": "BEGINNER",
    "tags": [
      "#Minimax",
      "#Video"
    ],
    "views": "36385",
    "author": "AI Expert",
    "topic": "Minimax",
    "url": "https://www.youtube.com/watch?v=dwpEP4TY1ME"
  },
  {
    "id": 86,
    "title": "Learn Adobe Illustrator 2025 in 1 Hour \u2013 Beginner\u2019s Full Crash Course",
    "thumbnail": "https://img.youtube.com/vi/h7komjsQq50/hqdefault.jpg",
    "duration": "1h09min",
    "level": "BEGINNER",
    "tags": [
      "#Adobe"
    ],
    "views": "37067",
    "author": "AI Expert",
    "topic": "Adobe",
    "url": "https://www.youtube.com/watch?v=h7komjsQq50"
  },
  {
    "id": 87,
    "title": "How to Create Custom GPTs in ChatGPT (OpenAI GPTs Tutorial for Beginners)",
    "thumbnail": "https://img.youtube.com/vi/2txql6RUSbk/hqdefault.jpg",
    "duration": "19min",
    "level": "BEGINNER",
    "tags": [
      "#Custom"
    ],
    "views": "33640",
    "author": "AI Expert",
    "topic": "Custom",
    "url": "https://www.youtube.com/watch?v=2txql6RUSbk"
  },
  {
    "id": 88,
    "title": "New AI-POWERED MASKS in Adobe Premiere - Tutorial",
    "thumbnail": "https://img.youtube.com/vi/SjHg6ePgBvI/hqdefault.jpg",
    "duration": "7min",
    "level": "ADVANCED",
    "tags": [
      "#Adobe"
    ],
    "views": "29850",
    "author": "AI Expert",
    "topic": "Adobe",
    "url": "https://www.youtube.com/watch?v=SjHg6ePgBvI"
  },
  {
    "id": 89,
    "title": "How to Install Ollama on Windows 11 | Use Ollama for Running AI Models Locally (2026)",
    "thumbnail": "https://img.youtube.com/vi/z7fhyKBAfzE/hqdefault.jpg",
    "duration": "5min",
    "level": "BEGINNER",
    "tags": [
      "#Install"
    ],
    "views": "35824",
    "author": "AI Expert",
    "topic": "Install",
    "url": "https://www.youtube.com/watch?v=z7fhyKBAfzE"
  },
  {
    "id": 90,
    "title": "How to create a great Microsoft Copilot prompt | Microsoft Copilot Tutorial",
    "thumbnail": "https://img.youtube.com/vi/9b0LOSjq39w/hqdefault.jpg",
    "duration": "1min",
    "level": "BEGINNER",
    "tags": [
      "#copilot"
    ],
    "views": "27283",
    "author": "AI Expert",
    "topic": "copilot",
    "url": "https://www.youtube.com/watch?v=9b0LOSjq39w"
  },
  {
    "id": 91,
    "title": "Quick Start with Similarweb: Set Up and Success",
    "thumbnail": "https://img.youtube.com/vi/iCksAF5cOr0/hqdefault.jpg",
    "duration": "27min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Quick"
    ],
    "views": "28845",
    "author": "AI Expert",
    "topic": "Quick",
    "url": "https://www.youtube.com/watch?v=iCksAF5cOr0"
  },
  {
    "id": 92,
    "title": "Klaviyo Email Marketing Flows Tutorial for 2026 (FULL SETUP)",
    "thumbnail": "https://img.youtube.com/vi/pjkqcWoN0NA/hqdefault.jpg",
    "duration": "46min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Klaviyo"
    ],
    "views": "30307",
    "author": "AI Expert",
    "topic": "Klaviyo",
    "url": "https://www.youtube.com/watch?v=pjkqcWoN0NA"
  },
  {
    "id": 93,
    "title": "Claude Cowork Course: Build AI Employees in 52 Minutes",
    "thumbnail": "https://img.youtube.com/vi/9BEWaO_eEFE/hqdefault.jpg",
    "duration": "52min",
    "level": "ADVANCED",
    "tags": [
      "#Claude"
    ],
    "views": "33075",
    "author": "AI Expert",
    "topic": "Claude",
    "url": "https://www.youtube.com/watch?v=9BEWaO_eEFE"
  },
  {
    "id": 94,
    "title": "Create CARTOON \ud83c\udf3c Images & Video - Use New Animations [Canva Tutorial]",
    "thumbnail": "https://img.youtube.com/vi/6WaJ2NdJUf0/hqdefault.jpg",
    "duration": "10min",
    "level": "BEGINNER",
    "tags": [
      "#canva"
    ],
    "views": "34332",
    "author": "AI Expert",
    "topic": "canva",
    "url": "https://www.youtube.com/watch?v=6WaJ2NdJUf0"
  },
  {
    "id": 95,
    "title": "Getting Started with GitHub Copilot CLI and Work IQ",
    "thumbnail": "https://img.youtube.com/vi/tQlNq8bH674/hqdefault.jpg",
    "duration": "25min",
    "level": "ADVANCED",
    "tags": [
      "#GitHub"
    ],
    "views": "30910",
    "author": "AI Expert",
    "topic": "GitHub",
    "url": "https://www.youtube.com/watch?v=tQlNq8bH674"
  },
  {
    "id": 96,
    "title": "HR Leaders: This Is the AI Course You Can\u2019t Ignore",
    "thumbnail": "https://img.youtube.com/vi/wsdi_6ltGdQ/hqdefault.jpg",
    "duration": "5min",
    "level": "INTERMEDIATE",
    "tags": [
      "#HR"
    ],
    "views": "26997",
    "author": "AI Expert",
    "topic": "Other",
    "url": "https://www.youtube.com/watch?v=wsdi_6ltGdQ"
  },
  {
    "id": 97,
    "title": "Start 2026 with Sales Intelligence Workflows That Do the Heavy Lifting",
    "thumbnail": "https://img.youtube.com/vi/xQPTs-b5naM/hqdefault.jpg",
    "duration": "48min",
    "level": "ADVANCED",
    "tags": [
      "#Sales"
    ],
    "views": "33409",
    "author": "AI Expert",
    "topic": "Sales",
    "url": "https://www.youtube.com/watch?v=xQPTs-b5naM"
  },
  {
    "id": 98,
    "title": "Microsoft 365 Copilot: Complete Tutorial for Beginners (2026)",
    "thumbnail": "https://img.youtube.com/vi/0_mqsU7yh5Q/hqdefault.jpg",
    "duration": "52min",
    "level": "BEGINNER",
    "tags": [
      "#Microsoft"
    ],
    "views": "32112",
    "author": "AI Expert",
    "topic": "Microsoft",
    "url": "https://www.youtube.com/watch?v=0_mqsU7yh5Q"
  },
  {
    "id": 99,
    "title": "Google Flow | Veo 3.1 Tutorial & Real Test Results",
    "thumbnail": "https://img.youtube.com/vi/H1QIXRFHAVU/hqdefault.jpg",
    "duration": "19min",
    "level": "BEGINNER",
    "tags": [
      "#Google"
    ],
    "views": "24783",
    "author": "AI Expert",
    "topic": "Google",
    "url": "https://www.youtube.com/watch?v=H1QIXRFHAVU"
  },
  {
    "id": 100,
    "title": "Open Source AI In 17 Minutes",
    "thumbnail": "https://img.youtube.com/vi/1uCE0uoKXL8/hqdefault.jpg",
    "duration": "17min",
    "level": "BEGINNER",
    "tags": [
      "#Open"
    ],
    "views": "22019",
    "author": "AI Expert",
    "topic": "Open",
    "url": "https://www.youtube.com/watch?v=1uCE0uoKXL8"
  },
  {
    "id": 101,
    "title": "How to Use Adobe Firefly 3 (& Why It's the Only AI Image Generator You Should Use)",
    "thumbnail": "https://img.youtube.com/vi/VNs1lW8t4hw/hqdefault.jpg",
    "duration": "9min",
    "level": "BEGINNER",
    "tags": [
      "#adobe"
    ],
    "views": "24091",
    "author": "AI Expert",
    "topic": "adobe",
    "url": "https://www.youtube.com/watch?v=VNs1lW8t4hw"
  },
  {
    "id": 102,
    "title": "Zapier For Beginners Tutorial",
    "thumbnail": "https://img.youtube.com/vi/QufC08E_zjU/hqdefault.jpg",
    "duration": "56min",
    "level": "BEGINNER",
    "tags": [
      "#Zapier"
    ],
    "views": "24609",
    "author": "AI Expert",
    "topic": "Zapier",
    "url": "https://www.youtube.com/watch?v=QufC08E_zjU"
  },
  {
    "id": 103,
    "title": "How to Actually Make 100% Consistent AI Characters",
    "thumbnail": "https://img.youtube.com/vi/h5kjDJrHw_g/hqdefault.jpg",
    "duration": "13min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Consistent"
    ],
    "views": "26871",
    "author": "AI Expert",
    "topic": "Consistent",
    "url": "https://www.youtube.com/watch?v=h5kjDJrHw_g"
  },
  {
    "id": 104,
    "title": "Stop making boring videos! | 10 MUST-KNOW Editing Hacks in CapCut (desktop)",
    "thumbnail": "https://img.youtube.com/vi/Frmd15hWJXU/hqdefault.jpg",
    "duration": "19min",
    "level": "ADVANCED",
    "tags": [
      "#Editing"
    ],
    "views": "32238",
    "author": "AI Expert",
    "topic": "Editing",
    "url": "https://www.youtube.com/watch?v=Frmd15hWJXU"
  },
  {
    "id": 105,
    "title": "Grammarly Tutorial: How to Improve Your Writing Instantly",
    "thumbnail": "https://img.youtube.com/vi/fU7OCJwA1a8/hqdefault.jpg",
    "duration": "7min",
    "level": "BEGINNER",
    "tags": [
      "#Grammarly"
    ],
    "views": "24789",
    "author": "AI Expert",
    "topic": "Grammarly",
    "url": "https://www.youtube.com/watch?v=fU7OCJwA1a8"
  },
  {
    "id": 106,
    "title": "How To Run Open Source AI Models",
    "thumbnail": "https://img.youtube.com/vi/vehYE1DfkZg/hqdefault.jpg",
    "duration": "17min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Open"
    ],
    "views": "27304",
    "author": "AI Expert",
    "topic": "Open",
    "url": "https://www.youtube.com/watch?v=vehYE1DfkZg"
  },
  {
    "id": 107,
    "title": "How To Master NotebookLM in 2026 (Free Course)",
    "thumbnail": "https://img.youtube.com/vi/b2fGNHPlUGA/hqdefault.jpg",
    "duration": "34min",
    "level": "ADVANCED",
    "tags": [
      "#Master"
    ],
    "views": "27860",
    "author": "AI Expert",
    "topic": "Master",
    "url": "https://www.youtube.com/watch?v=b2fGNHPlUGA"
  },
  {
    "id": 108,
    "title": "How to Generate Images with MORE DETAIL in Adobe Firefly",
    "thumbnail": "https://img.youtube.com/vi/bk2ijxo7Y98/hqdefault.jpg",
    "duration": "7min",
    "level": "BEGINNER",
    "tags": [
      "#adobe"
    ],
    "views": "23482",
    "author": "AI Expert",
    "topic": "adobe",
    "url": "https://www.youtube.com/watch?v=bk2ijxo7Y98"
  },
  {
    "id": 109,
    "title": "ChatPDF Tutorial | How to use ChatPDF AI to Chat with any PDF",
    "thumbnail": "https://img.youtube.com/vi/M-MuOfUWf-U/hqdefault.jpg",
    "duration": "8min",
    "level": "BEGINNER",
    "tags": [
      "#ChatPDF"
    ],
    "views": "21953",
    "author": "AI Expert",
    "topic": "ChatPDF",
    "url": "https://www.youtube.com/watch?v=M-MuOfUWf-U"
  },
  {
    "id": 110,
    "title": "(Replit Agent Tutorial) We Built THREE AI Apps Using ONLY AI in 58 Mins! \ud83e\udd2f",
    "thumbnail": "https://img.youtube.com/vi/Lq0FSpimDcs/hqdefault.jpg",
    "duration": "58min",
    "level": "BEGINNER",
    "tags": [
      "#Replit"
    ],
    "views": "31548",
    "author": "AI Expert",
    "topic": "Replit",
    "url": "https://www.youtube.com/watch?v=Lq0FSpimDcs"
  },
  {
    "id": 111,
    "title": "Adobe Firefly V3: A Complete 3D Tutorial",
    "thumbnail": "https://img.youtube.com/vi/Rkq_eDeGIMw/hqdefault.jpg",
    "duration": "12min",
    "level": "BEGINNER",
    "tags": [
      "#design"
    ],
    "views": "20378",
    "author": "AI Expert",
    "topic": "design",
    "url": "https://www.youtube.com/watch?v=Rkq_eDeGIMw"
  },
  {
    "id": 112,
    "title": "Photoshop - Train Your Custom Adobe Firefly 3 Image Model!",
    "thumbnail": "https://img.youtube.com/vi/bWZ_VPrFL1c/hqdefault.jpg",
    "duration": "8min",
    "level": "BEGINNER",
    "tags": [
      "#Adobe"
    ],
    "views": "26379",
    "author": "AI Expert",
    "topic": "Adobe",
    "url": "https://www.youtube.com/watch?v=bWZ_VPrFL1c"
  },
  {
    "id": 113,
    "title": "How To Use Adobe Firefly Structure Reference | Quick Tutorial",
    "thumbnail": "https://img.youtube.com/vi/sqcsj61BtBE/hqdefault.jpg",
    "duration": "9min",
    "level": "BEGINNER",
    "tags": [
      "#Adobe"
    ],
    "views": "27798",
    "author": "AI Expert",
    "topic": "Adobe",
    "url": "https://www.youtube.com/watch?v=sqcsj61BtBE"
  },
  {
    "id": 114,
    "title": "ChatGPT Tutorial - A Crash Course on Chat GPT for Beginners",
    "thumbnail": "https://img.youtube.com/vi/JTxsNm9IdYU/hqdefault.jpg",
    "duration": "34min",
    "level": "BEGINNER",
    "tags": [
      "#chatgpt"
    ],
    "views": "21873",
    "author": "AI Expert",
    "topic": "chatgpt",
    "url": "https://www.youtube.com/watch?v=JTxsNm9IdYU"
  },
  {
    "id": 115,
    "title": "Make.com Workflow Automation Tutorial for Beginners",
    "thumbnail": "https://img.youtube.com/vi/JSA2oezQWOU/hqdefault.jpg",
    "duration": "24min",
    "level": "BEGINNER",
    "tags": [
      "#kevin"
    ],
    "views": "26876",
    "author": "AI Expert",
    "topic": "kevin",
    "url": "https://www.youtube.com/watch?v=JSA2oezQWOU"
  },
  {
    "id": 116,
    "title": "Top 27 ChatGPT Make.com Automations [Automate With AI]",
    "thumbnail": "https://img.youtube.com/vi/cr3plCKOnVU/hqdefault.jpg",
    "duration": "16min",
    "level": "BEGINNER",
    "tags": [
      "#make"
    ],
    "views": "21164",
    "author": "AI Expert",
    "topic": "make",
    "url": "https://www.youtube.com/watch?v=cr3plCKOnVU"
  },
  {
    "id": 117,
    "title": "Automate Social Media Posts for your Blog with ChatGPT in Make.com",
    "thumbnail": "https://img.youtube.com/vi/P7UOzl44UjA/hqdefault.jpg",
    "duration": "33min",
    "level": "BEGINNER",
    "tags": [
      "#ChatGPT"
    ],
    "views": "22913",
    "author": "AI Expert",
    "topic": "ChatGPT",
    "url": "https://www.youtube.com/watch?v=P7UOzl44UjA"
  },
  {
    "id": 118,
    "title": "Automate Your ChatGPT Prompts in Make (formerly Integromat)",
    "thumbnail": "https://img.youtube.com/vi/FeUNSrVtRgw/hqdefault.jpg",
    "duration": "14min",
    "level": "BEGINNER",
    "tags": [
      "#no"
    ],
    "views": "20482",
    "author": "AI Expert",
    "topic": "Other",
    "url": "https://www.youtube.com/watch?v=FeUNSrVtRgw"
  },
  {
    "id": 119,
    "title": "Suno Prompting SECRETS! Powerful Metatags That Transform Your AI Music!",
    "thumbnail": "https://img.youtube.com/vi/D5FBP-vv72c/hqdefault.jpg",
    "duration": "19min",
    "level": "BEGINNER",
    "tags": [
      "#Suno"
    ],
    "views": "29526",
    "author": "AI Expert",
    "topic": "Suno",
    "url": "https://www.youtube.com/watch?v=D5FBP-vv72c"
  },
  {
    "id": 120,
    "title": "New PIKA AI Tutorial - Best FREE AI Video Generator Got UPGRADED!",
    "thumbnail": "https://img.youtube.com/vi/IJFxdV2LhYs/hqdefault.jpg",
    "duration": "14min",
    "level": "BEGINNER",
    "tags": [
      "#Pika",
      "#Video"
    ],
    "views": "21681",
    "author": "AI Expert",
    "topic": "Pika",
    "url": "https://www.youtube.com/watch?v=IJFxdV2LhYs"
  },
  {
    "id": 121,
    "title": "Google\u2019s NEW Prompting Guide is Incredible!",
    "thumbnail": "https://img.youtube.com/vi/o64Mv-ArFDI/hqdefault.jpg",
    "duration": "9min",
    "level": "BEGINNER",
    "tags": [
      "#Google"
    ],
    "views": "27998",
    "author": "AI Expert",
    "topic": "Google",
    "url": "https://www.youtube.com/watch?v=o64Mv-ArFDI"
  },
  {
    "id": 122,
    "title": "Lip Syncing Has Never Been Easier | PIka AI Video Tutorial",
    "thumbnail": "https://img.youtube.com/vi/hjGYM38jFI8/hqdefault.jpg",
    "duration": "7min",
    "level": "BEGINNER",
    "tags": [
      "#AI",
      "#Video"
    ],
    "views": "29201",
    "author": "AI Expert",
    "topic": "Video",
    "url": "https://www.youtube.com/watch?v=hjGYM38jFI8"
  },
  {
    "id": 123,
    "title": "Microsoft 365 Copilot | Security Risks & How to Protect Your Data",
    "thumbnail": "https://img.youtube.com/vi/ou2lYHhPbYk/hqdefault.jpg",
    "duration": "37min",
    "level": "BEGINNER",
    "tags": [
      "#Microsoft"
    ],
    "views": "22552",
    "author": "AI Expert",
    "topic": "Microsoft",
    "url": "https://www.youtube.com/watch?v=ou2lYHhPbYk"
  },
  {
    "id": 124,
    "title": "Pika Labs Secret That You Will Regret to Miss | Pika Labs Image to Video",
    "thumbnail": "https://img.youtube.com/vi/2iWSQk8Pjps/hqdefault.jpg",
    "duration": "5min",
    "level": "BEGINNER",
    "tags": [
      "#pika"
    ],
    "views": "22137",
    "author": "AI Expert",
    "topic": "pika",
    "url": "https://www.youtube.com/watch?v=2iWSQk8Pjps"
  },
  {
    "id": 125,
    "title": "How to use Azure OpenAI on your Data with Copilot Studio",
    "thumbnail": "https://img.youtube.com/vi/FmRmdCpnq8M/hqdefault.jpg",
    "duration": "16min",
    "level": "BEGINNER",
    "tags": [
      "#Azure",
      "#Studio"
    ],
    "views": "28104",
    "author": "AI Expert",
    "topic": "Azure",
    "url": "https://www.youtube.com/watch?v=FmRmdCpnq8M"
  },
  {
    "id": 126,
    "title": "Create Consistent Characters with Pose Control In Leonardo Ai!",
    "thumbnail": "https://img.youtube.com/vi/7ordFNVhmzo/hqdefault.jpg",
    "duration": "7min",
    "level": "BEGINNER",
    "tags": [
      "#Leonardo"
    ],
    "views": "20578",
    "author": "AI Expert",
    "topic": "Leonardo",
    "url": "https://www.youtube.com/watch?v=7ordFNVhmzo"
  },
  {
    "id": 127,
    "title": "Create a MOBILE app in 5 minutes with Replit and Expo - iOS / Android Supported",
    "thumbnail": "https://img.youtube.com/vi/mTm_dCF53qk/hqdefault.jpg",
    "duration": "8min",
    "level": "BEGINNER",
    "tags": [
      "#Replit"
    ],
    "views": "27223",
    "author": "AI Expert",
    "topic": "Replit",
    "url": "https://www.youtube.com/watch?v=mTm_dCF53qk"
  },
  {
    "id": 128,
    "title": "How to Create A Short Film with AI | Midjourney & RunwayML Tutorial",
    "thumbnail": "https://img.youtube.com/vi/6qOjhiYvmgE/hqdefault.jpg",
    "duration": "9min",
    "level": "BEGINNER",
    "tags": [
      "#ai",
      "#video",
      "#ai"
    ],
    "views": "24745",
    "author": "AI Expert",
    "topic": "video",
    "url": "https://www.youtube.com/watch?v=6qOjhiYvmgE"
  },
  {
    "id": 129,
    "title": "How to Create & Add Custom GPTs to Any Website in Seconds - Build your own ChatGPT",
    "thumbnail": "https://img.youtube.com/vi/HWhfVzyjeZ4/hqdefault.jpg",
    "duration": "2min",
    "level": "BEGINNER",
    "tags": [
      "#custom"
    ],
    "views": "22866",
    "author": "AI Expert",
    "topic": "custom",
    "url": "https://www.youtube.com/watch?v=HWhfVzyjeZ4"
  },
  {
    "id": 130,
    "title": "How To Make an App With ChatGPT (Without Knowing Code)",
    "thumbnail": "https://img.youtube.com/vi/5UYgJ4RFEBI/hqdefault.jpg",
    "duration": "11min",
    "level": "BEGINNER",
    "tags": [
      "#ChatGPT"
    ],
    "views": "21065",
    "author": "AI Expert",
    "topic": "ChatGPT",
    "url": "https://www.youtube.com/watch?v=5UYgJ4RFEBI"
  },
  {
    "id": 131,
    "title": "How To Use Brave - Best Web Browser With AI",
    "thumbnail": "https://img.youtube.com/vi/wEi1q1Uw9Dw/hqdefault.jpg",
    "duration": "11min",
    "level": "BEGINNER",
    "tags": [
      "#Bbrave"
    ],
    "views": "21951",
    "author": "AI Expert",
    "topic": "Bbrave",
    "url": "https://www.youtube.com/watch?v=wEi1q1Uw9Dw"
  },
  {
    "id": 132,
    "title": "How to Create and Use Perplexity Personal AI Chatbot Agents! #95",
    "thumbnail": "https://img.youtube.com/vi/JimBiXaL1nY/hqdefault.jpg",
    "duration": "17min",
    "level": "BEGINNER",
    "tags": [
      "#Perplexity"
    ],
    "views": "22969",
    "author": "AI Expert",
    "topic": "Perplexity",
    "url": "https://www.youtube.com/watch?v=JimBiXaL1nY"
  },
  {
    "id": 133,
    "title": "How to Use ChatGPT Voice to Learn Any Language for FREE",
    "thumbnail": "https://img.youtube.com/vi/w_6j9R6v0n4/hqdefault.jpg",
    "duration": "16min",
    "level": "BEGINNER",
    "tags": [
      "#ChatGPT"
    ],
    "views": "22056",
    "author": "AI Expert",
    "topic": "ChatGPT",
    "url": "https://www.youtube.com/watch?v=w_6j9R6v0n4"
  },
  {
    "id": 134,
    "title": "HubSpot CRM Tutorial for Beginners",
    "thumbnail": "https://img.youtube.com/vi/Ihu9rr1wRa0/hqdefault.jpg",
    "duration": "13min",
    "level": "BEGINNER",
    "tags": [
      "#hubspot"
    ],
    "views": "18497",
    "author": "AI Expert",
    "topic": "hubspot",
    "url": "https://www.youtube.com/watch?v=Ihu9rr1wRa0"
  },
  {
    "id": 135,
    "title": "Store Sensitive Data in HubSpot Smart CRM",
    "thumbnail": "https://img.youtube.com/vi/Ycz4FqzkYvU/hqdefault.jpg",
    "duration": "1min",
    "level": "BEGINNER",
    "tags": [
      "#HubSpot"
    ],
    "views": "19924",
    "author": "AI Expert",
    "topic": "HubSpot",
    "url": "https://www.youtube.com/watch?v=Ycz4FqzkYvU"
  },
  {
    "id": 136,
    "title": "Blog Writing Without Blogging Skills",
    "thumbnail": "https://img.youtube.com/vi/7fqE0-5ROWI/hqdefault.jpg",
    "duration": "7min",
    "level": "BEGINNER",
    "tags": [
      "#HubSpot"
    ],
    "views": "26178",
    "author": "AI Expert",
    "topic": "HubSpot",
    "url": "https://www.youtube.com/watch?v=7fqE0-5ROWI"
  },
  {
    "id": 137,
    "title": "Text-To-Speech: Generate Blogs And Podcasts With AI",
    "thumbnail": "https://img.youtube.com/vi/hJ2kwcRmPM4/hqdefault.jpg",
    "duration": "4min",
    "level": "BEGINNER",
    "tags": [
      "#hubspot",
      "#ai"
    ],
    "views": "18461",
    "author": "AI Expert",
    "topic": "hubspot",
    "url": "https://www.youtube.com/watch?v=hJ2kwcRmPM4"
  },
  {
    "id": 138,
    "title": "How To Automate Marketing And Sales Alignment (Tutorial)",
    "thumbnail": "https://img.youtube.com/vi/5ND7TO2--lo/hqdefault.jpg",
    "duration": "6min",
    "level": "BEGINNER",
    "tags": [
      "#HubSpot"
    ],
    "views": "16798",
    "author": "AI Expert",
    "topic": "HubSpot",
    "url": "https://www.youtube.com/watch?v=5ND7TO2--lo"
  },
  {
    "id": 139,
    "title": "Create A Business Website In Minutes With AI",
    "thumbnail": "https://img.youtube.com/vi/eHWzmz73d3I/hqdefault.jpg",
    "duration": "8min",
    "level": "BEGINNER",
    "tags": [
      "#HubSpot"
    ],
    "views": "17170",
    "author": "AI Expert",
    "topic": "HubSpot",
    "url": "https://www.youtube.com/watch?v=eHWzmz73d3I"
  },
  {
    "id": 140,
    "title": "Introducing Clip Creator: Free AI Video Generator",
    "thumbnail": "https://img.youtube.com/vi/MwdDFR17iS4/hqdefault.jpg",
    "duration": "4min",
    "level": "BEGINNER",
    "tags": [
      "#HubSpot"
    ],
    "views": "21387",
    "author": "AI Expert",
    "topic": "HubSpot",
    "url": "https://www.youtube.com/watch?v=MwdDFR17iS4"
  },
  {
    "id": 141,
    "title": "How To Use Marketing Automation (For Free)",
    "thumbnail": "https://img.youtube.com/vi/q_kDg2NRWo8/hqdefault.jpg",
    "duration": "7min",
    "level": "BEGINNER",
    "tags": [
      "#marketing"
    ],
    "views": "22644",
    "author": "AI Expert",
    "topic": "marketing",
    "url": "https://www.youtube.com/watch?v=q_kDg2NRWo8"
  },
  {
    "id": 142,
    "title": "How To Do Lead Management In Free HubSpot CRM",
    "thumbnail": "https://img.youtube.com/vi/wd8tbaS3nXY/hqdefault.jpg",
    "duration": "6min",
    "level": "BEGINNER",
    "tags": [
      "#HubSpot"
    ],
    "views": "20791",
    "author": "AI Expert",
    "topic": "HubSpot",
    "url": "https://www.youtube.com/watch?v=wd8tbaS3nXY"
  },
  {
    "id": 143,
    "title": "Get Started With The Model Context Protocol // 2-Minute Tutorial",
    "thumbnail": "https://img.youtube.com/vi/MC2BwMGFRx4/hqdefault.jpg",
    "duration": "2min",
    "level": "BEGINNER",
    "tags": [
      "#MCP"
    ],
    "views": "21598",
    "author": "AI Expert",
    "topic": "MCP",
    "url": "https://www.youtube.com/watch?v=MC2BwMGFRx4"
  },
  {
    "id": 144,
    "title": "HubSpot Starter Customer Platform Walkthrough (New Release!)",
    "thumbnail": "https://img.youtube.com/vi/vfW5Qwl_JQY/hqdefault.jpg",
    "duration": "31min",
    "level": "BEGINNER",
    "tags": [
      "#HubSpot"
    ],
    "views": "23865",
    "author": "AI Expert",
    "topic": "HubSpot",
    "url": "https://www.youtube.com/watch?v=vfW5Qwl_JQY"
  },
  {
    "id": 145,
    "title": "How To Log In Character AI App (2025) Easy Tutorial",
    "thumbnail": "https://img.youtube.com/vi/eqVRh_OzDcM/hqdefault.jpg",
    "duration": "1min",
    "level": "BEGINNER",
    "tags": [
      "#Character",
      "#ai"
    ],
    "views": "19047",
    "author": "AI Expert",
    "topic": "Character",
    "url": "https://www.youtube.com/watch?v=eqVRh_OzDcM"
  },
  {
    "id": 146,
    "title": "HubSpot AI Tools: Using HubSpot Content Assistant",
    "thumbnail": "https://img.youtube.com/vi/y0CT3JtNdN0/hqdefault.jpg",
    "duration": "14min",
    "level": "BEGINNER",
    "tags": [
      "#HubSpot",
      "#Tutorial"
    ],
    "views": "20824",
    "author": "AI Expert",
    "topic": "HubSpot",
    "url": "https://www.youtube.com/watch?v=y0CT3JtNdN0"
  },
  {
    "id": 147,
    "title": "Creating Images With ChatSpot | HubSpot AI",
    "thumbnail": "https://img.youtube.com/vi/mPPO9P-hK_c/hqdefault.jpg",
    "duration": "1min",
    "level": "BEGINNER",
    "tags": [
      "#ChatSpot",
      "#ai"
    ],
    "views": "21771",
    "author": "AI Expert",
    "topic": "ChatSpot",
    "url": "https://www.youtube.com/watch?v=mPPO9P-hK_c"
  },
  {
    "id": 148,
    "title": "NEW BEST AI MODEL! How to use Flux.",
    "thumbnail": "https://img.youtube.com/vi/3kljJNosQ1I/hqdefault.jpg",
    "duration": "10min",
    "level": "BEGINNER",
    "tags": [
      "#Flux"
    ],
    "views": "17775",
    "author": "AI Expert",
    "topic": "Flux",
    "url": "https://www.youtube.com/watch?v=3kljJNosQ1I"
  },
  {
    "id": 149,
    "title": "Flux.1 takes AI Image Customization to a whole new Level. [SUPER EASY GUIDE]",
    "thumbnail": "https://img.youtube.com/vi/FvCgYQgQexo/hqdefault.jpg",
    "duration": "18min",
    "level": "BEGINNER",
    "tags": [
      "#Flux.1"
    ],
    "views": "21460",
    "author": "AI Expert",
    "topic": "Flux.1",
    "url": "https://www.youtube.com/watch?v=FvCgYQgQexo"
  },
  {
    "id": 150,
    "title": "Flux and Forge Tutorial FAST Only 4 Steps - Save Space and TIME! #auto1111",
    "thumbnail": "https://img.youtube.com/vi/JlfS5EGbcmQ/hqdefault.jpg",
    "duration": "9min",
    "level": "BEGINNER",
    "tags": [
      "#Flux.1"
    ],
    "views": "17825",
    "author": "AI Expert",
    "topic": "Flux.1",
    "url": "https://www.youtube.com/watch?v=JlfS5EGbcmQ"
  },
  {
    "id": 151,
    "title": "How to Run Flux Image Models In ComfyUI with Low VRAM",
    "thumbnail": "https://img.youtube.com/vi/VvjwTneI2xk/hqdefault.jpg",
    "duration": "11min",
    "level": "BEGINNER",
    "tags": [
      "#Flux.1"
    ],
    "views": "21415",
    "author": "AI Expert",
    "topic": "Flux.1",
    "url": "https://www.youtube.com/watch?v=VvjwTneI2xk"
  },
  {
    "id": 152,
    "title": "The \"Secret Sauce\" to AI Model Consistency in 6 Easy Steps (ComfyUI)",
    "thumbnail": "https://img.youtube.com/vi/nVaHinkGnDA/hqdefault.jpg",
    "duration": "16min",
    "level": "BEGINNER",
    "tags": [
      "#comfyui"
    ],
    "views": "19289",
    "author": "AI Expert",
    "topic": "comfyui",
    "url": "https://www.youtube.com/watch?v=nVaHinkGnDA"
  },
  {
    "id": 153,
    "title": "How to Upscale with FLUX. Comfy Workflow.",
    "thumbnail": "https://img.youtube.com/vi/j-9m2hOcyiU/hqdefault.jpg",
    "duration": "8min",
    "level": "BEGINNER",
    "tags": [
      "#Flux"
    ],
    "views": "17259",
    "author": "AI Expert",
    "topic": "Flux",
    "url": "https://www.youtube.com/watch?v=j-9m2hOcyiU"
  },
  {
    "id": 154,
    "title": "How to Use Generative AI with Jes\u00fas Ramirez",
    "thumbnail": "https://img.youtube.com/vi/uzU2iYht3VU/hqdefault.jpg",
    "duration": "56min",
    "level": "BEGINNER",
    "tags": [
      "#Adobe"
    ],
    "views": "22648",
    "author": "AI Expert",
    "topic": "Adobe",
    "url": "https://www.youtube.com/watch?v=uzU2iYht3VU"
  },
  {
    "id": 155,
    "title": "Photoshop Ai Generative Fill Tutorial! - Complete Guide",
    "thumbnail": "https://img.youtube.com/vi/lpUhDw8JAjQ/hqdefault.jpg",
    "duration": "12min",
    "level": "BEGINNER",
    "tags": [
      "#Photoshop"
    ],
    "views": "15469",
    "author": "AI Expert",
    "topic": "Photoshop",
    "url": "https://www.youtube.com/watch?v=lpUhDw8JAjQ"
  },
  {
    "id": 156,
    "title": "Photoshop's EPIC AI Update: All New Features Explained",
    "thumbnail": "https://img.youtube.com/vi/cGT5Rp5po9o/hqdefault.jpg",
    "duration": "13min",
    "level": "BEGINNER",
    "tags": [
      "#photoshop"
    ],
    "views": "20490",
    "author": "AI Expert",
    "topic": "photoshop",
    "url": "https://www.youtube.com/watch?v=cGT5Rp5po9o"
  },
  {
    "id": 157,
    "title": "Photoshop AI for Beginners: 5 Game-Changing Features You Need to Try!",
    "thumbnail": "https://img.youtube.com/vi/lAV-43pPlVQ/hqdefault.jpg",
    "duration": "17min",
    "level": "BEGINNER",
    "tags": [
      "#Generative"
    ],
    "views": "15738",
    "author": "AI Expert",
    "topic": "Generative",
    "url": "https://www.youtube.com/watch?v=lAV-43pPlVQ"
  },
  {
    "id": 158,
    "title": "Adobe Premiere Pro: Advanced AI Editing Features You NEED To TRY!",
    "thumbnail": "https://img.youtube.com/vi/fQftbVN6sQ0/hqdefault.jpg",
    "duration": "7min",
    "level": "BEGINNER",
    "tags": [
      "#adobe"
    ],
    "views": "14371",
    "author": "AI Expert",
    "topic": "adobe",
    "url": "https://www.youtube.com/watch?v=fQftbVN6sQ0"
  },
  {
    "id": 159,
    "title": "Adobe Illustrator VECTORIZE Tutorial (Image Trace) Ai Art",
    "thumbnail": "https://img.youtube.com/vi/nkzi-Vg3dHo/hqdefault.jpg",
    "duration": "8min",
    "level": "BEGINNER",
    "tags": [
      "#Adobe"
    ],
    "views": "14040",
    "author": "AI Expert",
    "topic": "Adobe",
    "url": "https://www.youtube.com/watch?v=nkzi-Vg3dHo"
  },
  {
    "id": 160,
    "title": "Perplexity AI Pages - Say Goodbye to Writing Content",
    "thumbnail": "https://img.youtube.com/vi/VmjiE2mU2W8/hqdefault.jpg",
    "duration": "11min",
    "level": "BEGINNER",
    "tags": [
      "#Perplexity"
    ],
    "views": "19447",
    "author": "AI Expert",
    "topic": "Perplexity",
    "url": "https://www.youtube.com/watch?v=VmjiE2mU2W8"
  },
  {
    "id": 161,
    "title": "INVIDEO AI : NEW RELEASE - Create videos In 50+ languages | Faceless YouTube Automation",
    "thumbnail": "https://img.youtube.com/vi/6RlgzNdShZQ/hqdefault.jpg",
    "duration": "10min",
    "level": "BEGINNER",
    "tags": [
      "#INVIDEO"
    ],
    "views": "17227",
    "author": "AI Expert",
    "topic": "INVIDEO",
    "url": "https://www.youtube.com/watch?v=6RlgzNdShZQ"
  },
  {
    "id": 162,
    "title": "How to Create an App without any Coding - Appy Pie",
    "thumbnail": "https://img.youtube.com/vi/MA7lCcEJUhw/hqdefault.jpg",
    "duration": "1min",
    "level": "BEGINNER",
    "tags": [
      "#appy"
    ],
    "views": "15754",
    "author": "AI Expert",
    "topic": "appy",
    "url": "https://www.youtube.com/watch?v=MA7lCcEJUhw"
  },
  {
    "id": 163,
    "title": "NEW Adobe Podcast - Adobe AI Audio Editing Tool - Best Podcast Editing Software for Beginners",
    "thumbnail": "https://img.youtube.com/vi/y9pBvKh14G8/hqdefault.jpg",
    "duration": "8min",
    "level": "BEGINNER",
    "tags": [
      "#adobe"
    ],
    "views": "17358",
    "author": "AI Expert",
    "topic": "adobe",
    "url": "https://www.youtube.com/watch?v=y9pBvKh14G8"
  },
  {
    "id": 164,
    "title": "Writing A Blog Post Using ChatSpot | HubSpot AI",
    "thumbnail": "https://img.youtube.com/vi/3JHm1_tkJ7s/hqdefault.jpg",
    "duration": "2min",
    "level": "BEGINNER",
    "tags": [
      "#ChatSpot",
      "#ai"
    ],
    "views": "14564",
    "author": "AI Expert",
    "topic": "ChatSpot",
    "url": "https://www.youtube.com/watch?v=3JHm1_tkJ7s"
  },
  {
    "id": 165,
    "title": "Mastering UDIO: The Ultimate Guide to AI Music Creation",
    "thumbnail": "https://img.youtube.com/vi/oDKtyfyTTEc/hqdefault.jpg",
    "duration": "19min",
    "level": "BEGINNER",
    "tags": [
      "#Udio"
    ],
    "views": "17026",
    "author": "AI Expert",
    "topic": "Udio",
    "url": "https://www.youtube.com/watch?v=oDKtyfyTTEc"
  },
  {
    "id": 166,
    "title": "Udio Tutorial - How To Make A Full Song - Detailed Guide",
    "thumbnail": "https://img.youtube.com/vi/YBRfmIRzLoE/hqdefault.jpg",
    "duration": "11min",
    "level": "BEGINNER",
    "tags": [
      "#Udio"
    ],
    "views": "15681",
    "author": "AI Expert",
    "topic": "Udio",
    "url": "https://www.youtube.com/watch?v=YBRfmIRzLoE"
  },
  {
    "id": 167,
    "title": "Perplexity AI Tutorial - How To use Perplexity Ai for Research | Better than ChatGPT!",
    "thumbnail": "https://img.youtube.com/vi/3owELfRZPJU/hqdefault.jpg",
    "duration": "12min",
    "level": "BEGINNER",
    "tags": [
      "#perplexity",
      "#ai"
    ],
    "views": "18392",
    "author": "AI Expert",
    "topic": "perplexity",
    "url": "https://www.youtube.com/watch?v=3owELfRZPJU"
  },
  {
    "id": 168,
    "title": "Bolt tutorial for beginners with the Bolt CEO Eric Simons",
    "thumbnail": "https://img.youtube.com/vi/1SfUMQ1yTY8/hqdefault.jpg",
    "duration": "52min",
    "level": "BEGINNER",
    "tags": [
      "#Bolt"
    ],
    "views": "19869",
    "author": "AI Expert",
    "topic": "Bolt",
    "url": "https://www.youtube.com/watch?v=1SfUMQ1yTY8"
  },
  {
    "id": 169,
    "title": "How to add a database to your bolt.new app",
    "thumbnail": "https://img.youtube.com/vi/1GfqnOAKr9M/hqdefault.jpg",
    "duration": "7min",
    "level": "BEGINNER",
    "tags": [
      "#Bolt",
      "#nocode"
    ],
    "views": "13521",
    "author": "AI Expert",
    "topic": "Bolt",
    "url": "https://www.youtube.com/watch?v=1GfqnOAKr9M"
  },
  {
    "id": 170,
    "title": "Bolt.new Masterclass: How To Build AI Apps | STEP BY STEP",
    "thumbnail": "https://img.youtube.com/vi/tbDcJsMYBVw/hqdefault.jpg",
    "duration": "2h58min",
    "level": "BEGINNER",
    "tags": [
      "#bolt",
      "#ai"
    ],
    "views": "12991",
    "author": "AI Expert",
    "topic": "bolt",
    "url": "https://www.youtube.com/watch?v=tbDcJsMYBVw"
  },
  {
    "id": 171,
    "title": "Build a $1M App Using ONLY AI\u2014No Code Needed (Bolt.new Tutorial)",
    "thumbnail": "https://img.youtube.com/vi/e_vEI0fMPT8/hqdefault.jpg",
    "duration": "48min",
    "level": "BEGINNER",
    "tags": [
      "#Bolt"
    ],
    "views": "14031",
    "author": "AI Expert",
    "topic": "Bolt",
    "url": "https://www.youtube.com/watch?v=e_vEI0fMPT8"
  },
  {
    "id": 172,
    "title": "Recraft V3 - How to Create Stunning AI Images with Red Panda",
    "thumbnail": "https://img.youtube.com/vi/nn19PpVrJXQ/hqdefault.jpg",
    "duration": "12min",
    "level": "BEGINNER",
    "tags": [
      "#Recraft"
    ],
    "views": "17507",
    "author": "AI Expert",
    "topic": "Recraft",
    "url": "https://www.youtube.com/watch?v=nn19PpVrJXQ"
  },
  {
    "id": 173,
    "title": "How To Use Cursor AI For Beginners",
    "thumbnail": "https://img.youtube.com/vi/Rgz6mX93C4Y/hqdefault.jpg",
    "duration": "9min",
    "level": "BEGINNER",
    "tags": [
      "#Cursor"
    ],
    "views": "13228",
    "author": "AI Expert",
    "topic": "Cursor",
    "url": "https://www.youtube.com/watch?v=Rgz6mX93C4Y"
  },
  {
    "id": 174,
    "title": "N8N Full Tutorial: Building AI Agents in 2025 for Beginners!",
    "thumbnail": "https://img.youtube.com/vi/ZbIVOy_GPyQ/hqdefault.jpg",
    "duration": "31min",
    "level": "BEGINNER",
    "tags": [
      "#n8n"
    ],
    "views": "12433",
    "author": "AI Expert",
    "topic": "n8n",
    "url": "https://www.youtube.com/watch?v=ZbIVOy_GPyQ"
  },
  {
    "id": 175,
    "title": "n8n Masterclass: Build AI Agents & Automate Workflows (Beginner to Pro)",
    "thumbnail": "https://img.youtube.com/vi/ZHH3sr234zY/hqdefault.jpg",
    "duration": "1h31min",
    "level": "BEGINNER",
    "tags": [
      "#n8n"
    ],
    "views": "14791",
    "author": "AI Expert",
    "topic": "n8n",
    "url": "https://www.youtube.com/watch?v=ZHH3sr234zY"
  },
  {
    "id": 176,
    "title": "OpenManus AI Agent Tutorial: Build & Deploy in 15 Minutes (No Coding Required!)",
    "thumbnail": "https://img.youtube.com/vi/oayv1ah6-4M/hqdefault.jpg",
    "duration": "20min",
    "level": "BEGINNER",
    "tags": [
      "#OpenManus"
    ],
    "views": "13659",
    "author": "AI Expert",
    "topic": "OpenManus",
    "url": "https://www.youtube.com/watch?v=oayv1ah6-4M"
  },
  {
    "id": 177,
    "title": "Manus AI FULL 4.5 Hour Course",
    "thumbnail": "https://img.youtube.com/vi/sKJW5QOPRy4/hqdefault.jpg",
    "duration": "4h45min",
    "level": "BEGINNER",
    "tags": [
      "#Manus"
    ],
    "views": "13492",
    "author": "AI Expert",
    "topic": "Manus",
    "url": "https://www.youtube.com/watch?v=sKJW5QOPRy4"
  },
  {
    "id": 178,
    "title": "Google AI Studio in 26 Minutes",
    "thumbnail": "https://img.youtube.com/vi/13EPujO40iE/hqdefault.jpg",
    "duration": "26min",
    "level": "BEGINNER",
    "tags": [
      "#Google",
      "#Studio"
    ],
    "views": "14927",
    "author": "AI Expert",
    "topic": "Google",
    "url": "https://www.youtube.com/watch?v=13EPujO40iE"
  },
  {
    "id": 179,
    "title": "How to Use Hunyuan: The Best FREE AI Video Model | ComfyUI Tutorial",
    "thumbnail": "https://img.youtube.com/vi/ox9M9CMDYi8/hqdefault.jpg",
    "duration": "11min",
    "level": "BEGINNER",
    "tags": [
      "#hunyuan",
      "#video"
    ],
    "views": "12750",
    "author": "AI Expert",
    "topic": "hunyuan",
    "url": "https://www.youtube.com/watch?v=ox9M9CMDYi8"
  },
  {
    "id": 180,
    "title": "Kling AI ELEMENTS Course: Multiple Consistent Characters, Clothing, Objects, Environments is HERE!",
    "thumbnail": "https://img.youtube.com/vi/NkpY_aL-ZLQ/hqdefault.jpg",
    "duration": "15min",
    "level": "BEGINNER",
    "tags": [
      "#kling",
      "#ai"
    ],
    "views": "17458",
    "author": "AI Expert",
    "topic": "kling",
    "url": "https://www.youtube.com/watch?v=NkpY_aL-ZLQ"
  },
  {
    "id": 181,
    "title": "23 NEW Midjourney Tips because I like you",
    "thumbnail": "https://img.youtube.com/vi/GZKeCAq_4TQ/hqdefault.jpg",
    "duration": "23min",
    "level": "BEGINNER",
    "tags": [
      "#Midjourney",
      "#ai"
    ],
    "views": "15074",
    "author": "AI Expert",
    "topic": "Midjourney",
    "url": "https://www.youtube.com/watch?v=GZKeCAq_4TQ"
  },
  {
    "id": 182,
    "title": "Frase AI: The Ultimate Tool for Content Creation and SEO Success",
    "thumbnail": "https://img.youtube.com/vi/8VhgNXrSouo/hqdefault.jpg",
    "duration": "1min",
    "level": "BEGINNER",
    "tags": [
      "#FraseAI"
    ],
    "views": "14020",
    "author": "AI Expert",
    "topic": "FraseAI",
    "url": "https://www.youtube.com/watch?v=8VhgNXrSouo"
  },
  {
    "id": 183,
    "title": "How to Install DeepSeek on Windows",
    "thumbnail": "https://img.youtube.com/vi/g8cmwCWtggg/hqdefault.jpg",
    "duration": "8min",
    "level": "BEGINNER",
    "tags": [
      "#DeepSeek"
    ],
    "views": "14997",
    "author": "AI Expert",
    "topic": "DeepSeek",
    "url": "https://www.youtube.com/watch?v=g8cmwCWtggg"
  },
  {
    "id": 184,
    "title": "The BEST Image To 3D Model is FREE? Install Hunyuan2.0 Tutorial",
    "thumbnail": "https://img.youtube.com/vi/4dZ2L7VY94A/hqdefault.jpg",
    "duration": "7min",
    "level": "BEGINNER",
    "tags": [
      "#Hunyuan",
      "#Video"
    ],
    "views": "16486",
    "author": "AI Expert",
    "topic": "Hunyuan",
    "url": "https://www.youtube.com/watch?v=4dZ2L7VY94A"
  },
  {
    "id": 185,
    "title": "Cursor AI Tutorial for Beginners [2025 Edition]",
    "thumbnail": "https://img.youtube.com/vi/3289vhOUdKA/hqdefault.jpg",
    "duration": "27min",
    "level": "BEGINNER",
    "tags": [
      "#Cursor"
    ],
    "views": "16610",
    "author": "AI Expert",
    "topic": "Cursor",
    "url": "https://www.youtube.com/watch?v=3289vhOUdKA"
  },
  {
    "id": 186,
    "title": "Model Context Protocol (MCP), clearly explained (why it matters)",
    "thumbnail": "https://img.youtube.com/vi/7j_NE6Pjv-E/hqdefault.jpg",
    "duration": "20min",
    "level": "BEGINNER",
    "tags": [
      "#Model"
    ],
    "views": "10628",
    "author": "AI Expert",
    "topic": "Model",
    "url": "https://www.youtube.com/watch?v=7j_NE6Pjv-E"
  },
  {
    "id": 187,
    "title": "The Complete Perplexity Tutorial 2025 (+ Comet Browser)",
    "thumbnail": "https://img.youtube.com/vi/ISeZc6qKUSw/hqdefault.jpg",
    "duration": "13min",
    "level": "BEGINNER",
    "tags": [
      "#Perplexity"
    ],
    "views": "14299",
    "author": "AI Expert",
    "topic": "Perplexity",
    "url": "https://www.youtube.com/watch?v=ISeZc6qKUSw"
  },
  {
    "id": 188,
    "title": "Semrush Tutorial for Beginners 2025 (Complete SEO Guide)",
    "thumbnail": "https://img.youtube.com/vi/FqOIYEO8zUQ/hqdefault.jpg",
    "duration": "50min",
    "level": "BEGINNER",
    "tags": [
      "#Semrush"
    ],
    "views": "15335",
    "author": "AI Expert",
    "topic": "Semrush",
    "url": "https://www.youtube.com/watch?v=FqOIYEO8zUQ"
  },
  {
    "id": 189,
    "title": "ClickUp Tutorial 2025 - How to Use ClickUp for Beginners",
    "thumbnail": "https://img.youtube.com/vi/JmcVjP8m02k/hqdefault.jpg",
    "duration": "37min",
    "level": "BEGINNER",
    "tags": [
      "#clickup"
    ],
    "views": "14882",
    "author": "AI Expert",
    "topic": "clickup",
    "url": "https://www.youtube.com/watch?v=JmcVjP8m02k"
  },
  {
    "id": 190,
    "title": "CapCut Tutorial for Beginners (2025) \u2013 Full Video Editing Guide",
    "thumbnail": "https://img.youtube.com/vi/j5_471mO14c/hqdefault.jpg",
    "duration": "14min",
    "level": "BEGINNER",
    "tags": [
      "#CapCut",
      "#video"
    ],
    "views": "12785",
    "author": "AI Expert",
    "topic": "CapCut",
    "url": "https://www.youtube.com/watch?v=j5_471mO14c"
  },
  {
    "id": 191,
    "title": "CapCut Tutorial for Beginners 2025 - Step by Step",
    "thumbnail": "https://img.youtube.com/vi/EMDrgqepVhM/hqdefault.jpg",
    "duration": "1h04min",
    "level": "BEGINNER",
    "tags": [
      "#CapCut",
      "#video"
    ],
    "views": "10666",
    "author": "AI Expert",
    "topic": "CapCut",
    "url": "https://www.youtube.com/watch?v=EMDrgqepVhM"
  },
  {
    "id": 192,
    "title": "The ULTIMATE GPT-5 Guide 2025: How to Use Chat GPT-5 For Beginners",
    "thumbnail": "https://img.youtube.com/vi/n7gxTAwQ634/hqdefault.jpg",
    "duration": "37min",
    "level": "BEGINNER",
    "tags": [
      "#GPT-5"
    ],
    "views": "13195",
    "author": "AI Expert",
    "topic": "GPT-5",
    "url": "https://www.youtube.com/watch?v=n7gxTAwQ634"
  },
  {
    "id": 193,
    "title": "AnimateDiff Tutorial: Turn Videos to A.I Animation | IPAdapter x ComfyUI",
    "thumbnail": "https://img.youtube.com/vi/AugFKDGyVuw/hqdefault.jpg",
    "duration": "11min",
    "level": "BEGINNER",
    "tags": [
      "#AnimateDiff",
      "#video",
      "#ai"
    ],
    "views": "14390",
    "author": "AI Expert",
    "topic": "AnimateDiff",
    "url": "https://www.youtube.com/watch?v=AugFKDGyVuw"
  },
  {
    "id": 194,
    "title": "Ultimate VEO 3.1 Update EXPLAINED: How To Use Google Veo-3 For Beginners",
    "thumbnail": "https://img.youtube.com/vi/FMdIIBByNZo/hqdefault.jpg",
    "duration": "19min",
    "level": "BEGINNER",
    "tags": [
      "#Google"
    ],
    "views": "9493",
    "author": "AI Expert",
    "topic": "Google",
    "url": "https://www.youtube.com/watch?v=FMdIIBByNZo"
  },
  {
    "id": 195,
    "title": "Google Veo 3 Tutorial: Create Ai Videos In 5 Minutes",
    "thumbnail": "https://img.youtube.com/vi/mn9iNgKqTDk/hqdefault.jpg",
    "duration": "12min",
    "level": "BEGINNER",
    "tags": [
      "#Google"
    ],
    "views": "12287",
    "author": "AI Expert",
    "topic": "Google",
    "url": "https://www.youtube.com/watch?v=mn9iNgKqTDk"
  },
  {
    "id": 196,
    "title": "Sora 2 Full Tutorial: Mobile + Web Features Explained",
    "thumbnail": "https://img.youtube.com/vi/7qp743xznMU/hqdefault.jpg",
    "duration": "13min",
    "level": "BEGINNER",
    "tags": [
      "#Sora",
      "#Video"
    ],
    "views": "12589",
    "author": "AI Expert",
    "topic": "Sora",
    "url": "https://www.youtube.com/watch?v=7qp743xznMU"
  },
  {
    "id": 197,
    "title": "How To Use Seedream 4.0 Text To Image Generator (Tutorial For Beginners)",
    "thumbnail": "https://img.youtube.com/vi/Y1gLBcN4aV4/hqdefault.jpg",
    "duration": "8min",
    "level": "BEGINNER",
    "tags": [
      "#Seedream"
    ],
    "views": "11878",
    "author": "AI Expert",
    "topic": "Seedream",
    "url": "https://www.youtube.com/watch?v=Y1gLBcN4aV4"
  },
  {
    "id": 198,
    "title": "The ULTIMATE Beginners Guide to Midjourney",
    "thumbnail": "https://img.youtube.com/vi/vUj4VNXXC1c/hqdefault.jpg",
    "duration": "55min",
    "level": "BEGINNER",
    "tags": [
      "#midjourney",
      "#ai"
    ],
    "views": "12498",
    "author": "AI Expert",
    "topic": "midjourney",
    "url": "https://www.youtube.com/watch?v=vUj4VNXXC1c"
  },
  {
    "id": 199,
    "title": "Nano Banana AI Tutorial | How to Use Google\u2019s Free Tool (Step-by-Step)",
    "thumbnail": "https://img.youtube.com/vi/lfE-csUyPF4/hqdefault.jpg",
    "duration": "7min",
    "level": "BEGINNER",
    "tags": [
      "#Nano"
    ],
    "views": "13179",
    "author": "AI Expert",
    "topic": "Nano",
    "url": "https://www.youtube.com/watch?v=lfE-csUyPF4"
  },
  {
    "id": 200,
    "title": "How To Use New Google Gemini (Gemini AI Tutorial) Complete Guide With Tips and Tricks",
    "thumbnail": "https://img.youtube.com/vi/XAUScNfVvh8/hqdefault.jpg",
    "duration": "21min",
    "level": "BEGINNER",
    "tags": [
      "#Gemini"
    ],
    "views": "11743",
    "author": "AI Expert",
    "topic": "Gemini",
    "url": "https://www.youtube.com/watch?v=XAUScNfVvh8"
  },
  {
    "id": 201,
    "title": "How To Use Nano Banana AI (EASY TUTORIAL)",
    "thumbnail": "https://img.youtube.com/vi/lUahfloeI9Y/hqdefault.jpg",
    "duration": "10min",
    "level": "BEGINNER",
    "tags": [
      "#Nano"
    ],
    "views": "13328",
    "author": "AI Expert",
    "topic": "Nano",
    "url": "https://www.youtube.com/watch?v=lUahfloeI9Y"
  },
  {
    "id": 202,
    "title": "ULTIMATE NANO BANANA TUTORIAL: 15 PROMPT TECHNIQUES",
    "thumbnail": "https://img.youtube.com/vi/nnlgMpyq-j0/hqdefault.jpg",
    "duration": "19min",
    "level": "BEGINNER",
    "tags": [
      "#Nano"
    ],
    "views": "13023",
    "author": "AI Expert",
    "topic": "Nano",
    "url": "https://www.youtube.com/watch?v=nnlgMpyq-j0"
  },
  {
    "id": 203,
    "title": "The BEST FREE AI Video Model | WAN 2.2 ComfyUI Tutorial",
    "thumbnail": "https://img.youtube.com/vi/CfdyO2ikv88/hqdefault.jpg",
    "duration": "16min",
    "level": "BEGINNER",
    "tags": [
      "#"
    ],
    "views": "11831",
    "author": "AI Expert",
    "topic": "Other",
    "url": "https://www.youtube.com/watch?v=CfdyO2ikv88"
  },
  {
    "id": 204,
    "title": "Wan 2.2 AI Video Model Tutorial Guide To Get Started In ComfyUI - It Released Finally!",
    "thumbnail": "https://img.youtube.com/vi/kDgOhDQZMy0/hqdefault.jpg",
    "duration": "31min",
    "level": "BEGINNER",
    "tags": [
      "#WAN",
      "#video"
    ],
    "views": "9966",
    "author": "AI Expert",
    "topic": "WAN",
    "url": "https://www.youtube.com/watch?v=kDgOhDQZMy0"
  },
  {
    "id": 205,
    "title": "How to use KLING AI Avatar - Lip Sync (Image to Video)",
    "thumbnail": "https://img.youtube.com/vi/y1MEGzMKzNs/hqdefault.jpg",
    "duration": "18min",
    "level": "BEGINNER",
    "tags": [
      "#Kling",
      "#ai"
    ],
    "views": "9010",
    "author": "AI Expert",
    "topic": "Kling",
    "url": "https://www.youtube.com/watch?v=y1MEGzMKzNs"
  },
  {
    "id": 206,
    "title": "Generate UNLIMITED SeeDream 4.0 Images | AI Secret",
    "thumbnail": "https://img.youtube.com/vi/i1baLDeEd-U/hqdefault.jpg",
    "duration": "5min",
    "level": "BEGINNER",
    "tags": [
      "#SeedDream"
    ],
    "views": "12806",
    "author": "AI Expert",
    "topic": "SeedDream",
    "url": "https://www.youtube.com/watch?v=i1baLDeEd-U"
  },
  {
    "id": 207,
    "title": "WAN 2.5 is a BEAST (Complete Guide)",
    "thumbnail": "https://img.youtube.com/vi/2YEvXE4t8FM/hqdefault.jpg",
    "duration": "14min",
    "level": "BEGINNER",
    "tags": [
      "#WAN",
      "#video"
    ],
    "views": "8356",
    "author": "AI Expert",
    "topic": "WAN",
    "url": "https://www.youtube.com/watch?v=2YEvXE4t8FM"
  },
  {
    "id": 208,
    "title": "Create VIRAL Ai Video Effects (Higgsfield Ai Tutorial)",
    "thumbnail": "https://img.youtube.com/vi/vWD-RSKf00s/hqdefault.jpg",
    "duration": "4min",
    "level": "BEGINNER",
    "tags": [
      "#Higgsfield",
      "#video",
      "#ai"
    ],
    "views": "9896",
    "author": "AI Expert",
    "topic": "Higgsfield",
    "url": "https://www.youtube.com/watch?v=vWD-RSKf00s"
  },
  {
    "id": 209,
    "title": "Semrush Tutorial for AI SEO in 2025 (Beginner Friendly)",
    "thumbnail": "https://img.youtube.com/vi/H9LbJOyT6G8/hqdefault.jpg",
    "duration": "21min",
    "level": "BEGINNER",
    "tags": [
      "#Semrush"
    ],
    "views": "9168",
    "author": "AI Expert",
    "topic": "Semrush",
    "url": "https://www.youtube.com/watch?v=H9LbJOyT6G8"
  },
  {
    "id": 210,
    "title": "How to Write Perfect AI Prompts in 2025 (Complete Guide)",
    "thumbnail": "https://img.youtube.com/vi/P08jrZhyNxw/hqdefault.jpg",
    "duration": "4min",
    "level": "BEGINNER",
    "tags": [
      "#Prompts"
    ],
    "views": "12422",
    "author": "AI Expert",
    "topic": "Prompts",
    "url": "https://www.youtube.com/watch?v=P08jrZhyNxw"
  },
  {
    "id": 211,
    "title": "Google's 9 Hour AI Prompt Engineering Course In 20 Minutes",
    "thumbnail": "https://img.youtube.com/vi/p09yRj47kNM/hqdefault.jpg",
    "duration": "20min",
    "level": "BEGINNER",
    "tags": [
      "#Gemini"
    ],
    "views": "10397",
    "author": "AI Expert",
    "topic": "Gemini",
    "url": "https://www.youtube.com/watch?v=p09yRj47kNM"
  },
  {
    "id": 212,
    "title": "The ONLY Google Gemini Tutorial You Need! How To Use Gemini Like a Pro in 18 Minutes",
    "thumbnail": "https://img.youtube.com/vi/KSk8SOob79Q/hqdefault.jpg",
    "duration": "18min",
    "level": "BEGINNER",
    "tags": [
      "#"
    ],
    "views": "8316",
    "author": "AI Expert",
    "topic": "Other",
    "url": "https://www.youtube.com/watch?v=KSk8SOob79Q"
  },
  {
    "id": 213,
    "title": "Master Google Ai Studio in 15 Minutes",
    "thumbnail": "https://img.youtube.com/vi/-aT3Uh1hyis/hqdefault.jpg",
    "duration": "17min",
    "level": "ADVANCED",
    "tags": [
      "#Google",
      "#Studio"
    ],
    "views": "8305",
    "author": "AI Expert",
    "topic": "Google",
    "url": "https://www.youtube.com/watch?v=-aT3Uh1hyis"
  },
  {
    "id": 214,
    "title": "Everything Free You Can Do With Gemini",
    "thumbnail": "https://img.youtube.com/vi/NDf0p5hgjvk/hqdefault.jpg",
    "duration": "34min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Gemini"
    ],
    "views": "7978",
    "author": "AI Expert",
    "topic": "Gemini",
    "url": "https://www.youtube.com/watch?v=NDf0p5hgjvk"
  },
  {
    "id": 215,
    "title": "Google\u2019s NotebookLM is Getting Even More Powerful",
    "thumbnail": "https://img.youtube.com/vi/i9kiuGIHlMY/hqdefault.jpg",
    "duration": "27min",
    "level": "BEGINNER",
    "tags": [
      "#NotebookLM"
    ],
    "views": "7136",
    "author": "AI Expert",
    "topic": "NotebookLM",
    "url": "https://www.youtube.com/watch?v=i9kiuGIHlMY"
  },
  {
    "id": 216,
    "title": "Notion AI Agent \u2014 7 Powerful Things It Can Do for You",
    "thumbnail": "https://img.youtube.com/vi/8tMM2h_XGR0/hqdefault.jpg",
    "duration": "11min",
    "level": "INTERMEDIATE",
    "tags": [
      "#Notion"
    ],
    "views": "6029",
    "author": "AI Expert",
    "topic": "Notion",
    "url": "https://www.youtube.com/watch?v=8tMM2h_XGR0"
  },
  {
    "id": 217,
    "title": "How I Deploy Apps With Google AI Studio \ud83d\ude80 Full Tutorial",
    "thumbnail": "https://img.youtube.com/vi/X_JBFLs3vAk/hqdefault.jpg",
    "duration": "29min",
    "level": "ADVANCED",
    "tags": [
      "#Google",
      "#Studio"
    ],
    "views": "8504",
    "author": "AI Expert",
    "topic": "Google",
    "url": "https://www.youtube.com/watch?v=X_JBFLs3vAk"
  },
  {
    "id": 218,
    "title": "How to Create Animated AI Influencers (Step by Step)",
    "thumbnail": "https://img.youtube.com/vi/qlxfsepdSx8/hqdefault.jpg",
    "duration": "9min",
    "level": "INTERMEDIATE",
    "tags": [
      "#AI",
      "#Video"
    ],
    "views": "8051",
    "author": "AI Expert",
    "topic": "Video",
    "url": "https://www.youtube.com/watch?v=qlxfsepdSx8"
  },
  {
    "id": 219,
    "title": "Claude Code Tutorial #1 - Introduction & Setup",
    "thumbnail": "https://img.youtube.com/vi/SUysp3sJHbA/hqdefault.jpg",
    "duration": "10min",
    "level": "ADVANCED",
    "tags": [
      "#Claude"
    ],
    "views": "7155",
    "author": "AI Expert",
    "topic": "Claude",
    "url": "https://www.youtube.com/watch?v=SUysp3sJHbA"
  }
];

export const MOCK_TOPICS = ["All", "ChatGPT", "NotebookLM", "ElevenLabs", "Claude", "Gemini", "Runway", "HeyGen", "Midjourney", "HubSpot", "Perplexity", "Notion", "Kling AI", "Copilot", "Canva", "Nano Banana", "Firefly", "n8n", "Suno", "Cursor", "GitHub", "Leonardo", "Zapier", "CapCut", "Prompt"];
